import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createVNode as _createVNode, withModifiers as _withModifiers, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, vModelText as _vModelText, withKeys as _withKeys, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '@/assets/imgcaptions/aiLogo.png'
import _imports_1 from '@/assets/imgcaptions/icon_gongjulan_1.1.png'
import _imports_2 from '@/assets/imgcaptions/icon_chexiao.svg'
import _imports_3 from '@/assets/imgcaptions/icon_chexiao2.svg'
import _imports_4 from '@/assets/imgcaptions/icon_fanjian.svg'
import _imports_5 from '@/assets/imgcaptions/icon_fanjiansel.svg'
import _imports_6 from '@/assets/imgcaptions/icon_gongju_5.2.png'
import _imports_7 from '@/assets/imgcaptions/icon_gongju_6.1.png'
import _imports_8 from '@/assets/imgcaptions/icon_gongju_6.png'
import _imports_9 from '@/assets/imgcaptions/deltranslat.png'
import _imports_10 from '@/assets/imgcaptions/icon_jcguize.svg'
import _imports_11 from '@/assets/imgcaptions/icon_jcguizesel.svg'
import _imports_12 from '@/assets/imgcaptions/icon_gongju_9.1.png'
import _imports_13 from '@/assets/imgcaptions/icon_gongju_9.png'
import _imports_14 from '@/assets/imgcaptions/icon_gongju_10.1.png'
import _imports_15 from '@/assets/imgcaptions/icon_gongju_10.png'
import _imports_16 from '@/assets/imgcaptions/icon_gongju_11.1.png'
import _imports_17 from '@/assets/imgcaptions/icon_gongju_11.png'
import _imports_18 from '@/assets/imgcaptions/icon_gongju_12.1.png'
import _imports_19 from '@/assets/imgcaptions/icon_gongju_12.png'
import _imports_20 from '@/assets/imgcaptions/icon_shijianma.svg'
import _imports_21 from '@/assets/imgcaptions/icon_shijianmasel.svg'
import _imports_22 from '@/assets/imgcaptions/icon_gongju_14.1.png'
import _imports_23 from '@/assets/imgcaptions/shareBox.svg'
import _imports_24 from '@/assets/imgcaptions/shareBoxSel.svg'
import _imports_25 from '@/assets/imgcaptions/icon_gongju_15.1.png'
import _imports_26 from '@/assets/imgcaptions/icon_touxiangbianji.svg'
import _imports_27 from '@/assets/imgcaptions/linePoint.png'
import _imports_28 from '@/assets/imgcaptions/icon_zuida.svg'
import _imports_29 from '@/assets/imgcaptions/icon_zuixiao.svg'
import _imports_30 from '@/assets/imgcaptions/play.svg'
import _imports_31 from '@/assets/imgcaptions/pause.svg'
import _imports_32 from '@/assets/imgcaptions/icon_pinglun.svg'
import _imports_33 from '@/assets/imgcaptions/icon_zimubj_6.png'
import _imports_34 from '@/assets/imgcaptions/icon_zimubj_7.png'
import _imports_35 from '@/assets/imgcaptions/icon_zimubj_2.png'
import _imports_36 from '@/assets/imgcaptions/icon_zimubj_3.png'
import _imports_37 from '@/assets/imgcaptions/icon_zimubj_4.png'
import _imports_38 from '@/assets/imgcaptions/icon_zimubj_5.png'
import _imports_39 from '@/assets/svg/loding2.gif'


const _hoisted_1 = {
  class: "captionsBox",
  onselectstart: "return false;"
}
const _hoisted_2 = { class: "captionsStyle" }
const _hoisted_3 = { class: "captionsTop" }
const _hoisted_4 = { class: "topRout" }
const _hoisted_5 = { class: "captionsTitle" }
const _hoisted_6 = { class: "text" }
const _hoisted_7 = { class: "titleSave topCommentCss" }
const _hoisted_8 = { class: "titleRevoke" }
const _hoisted_9 = { class: "topCommentCss titleSimplified" }
const _hoisted_10 = { class: "topCommentCss titleTransAi" }
const _hoisted_11 = { class: "topCommentCss" }
const _hoisted_12 = { class: "topCommentCss" }
const _hoisted_13 = { class: "topCommentCss titleInspect" }
const _hoisted_14 = { class: "topCommentCss" }
const _hoisted_15 = { class: "topCommentCss titleUploadSr" }
const _hoisted_16 = { class: "topCommentCss titleDownload" }
const _hoisted_17 = {
  key: 0,
  class: "topCommentCss"
}
const _hoisted_18 = { class: "topCommentCss" }
const _hoisted_19 = { class: "topCommentCss" }
const _hoisted_20 = {
  key: 1,
  class: "topCommentCss"
}
const _hoisted_21 = {
  key: 2,
  class: "topCommentCss titleShare"
}
const _hoisted_22 = { class: "titleVersion" }
const _hoisted_23 = { class: "versionBoxName" }
const _hoisted_24 = { class: "topCommentCss titleBackList" }
const _hoisted_25 = { class: "videoBoxTitle" }
const _hoisted_26 = { class: "videoBoxTitleTxt" }
const _hoisted_27 = ["src"]
const _hoisted_28 = ["src", "muted"]
const _hoisted_29 = ["src"]
const _hoisted_30 = { class: "roleList" }
const _hoisted_31 = {
  key: 0,
  class: "rolesOut"
}
const _hoisted_32 = { class: "roles" }
const _hoisted_33 = { class: "roleListBox" }
const _hoisted_34 = ["onMouseover"]
const _hoisted_35 = { class: "roleOneBoxImg" }
const _hoisted_36 = ["src"]
const _hoisted_37 = ["src"]
const _hoisted_38 = { class: "roleOneBoxName" }
const _hoisted_39 = {
  key: 0,
  class: "roleOneBoxHover"
}
const _hoisted_40 = ["onClick"]
const _hoisted_41 = {
  key: 0,
  class: "roleOneTts"
}
const _hoisted_42 = { class: "roleOneBoxInner" }
const _hoisted_43 = { class: "roleOneBoxImg" }
const _hoisted_44 = ["src"]
const _hoisted_45 = { class: "captionsBtmRightBox" }
const _hoisted_46 = { class: "captionsBtmRightIn" }
const _hoisted_47 = { class: "captionsTableBox" }
const _hoisted_48 = {
  key: 0,
  class: "timeNumber"
}
const _hoisted_49 = {
  key: 1,
  class: "rolesImgs"
}
const _hoisted_50 = { class: "tableHeadRight" }
const _hoisted_51 = { class: "captionsText" }
const _hoisted_52 = { class: "captionsTextWord" }
const _hoisted_53 = {
  key: 0,
  class: "captionsshareImgList"
}
const _hoisted_54 = ["src"]
const _hoisted_55 = ["src"]
const _hoisted_56 = { class: "tableHeadLarge" }
const _hoisted_57 = { class: "captionsTableListBox" }
const _hoisted_58 = ["onContextmenu", "onMouseover"]
const _hoisted_59 = ["onClick"]
const _hoisted_60 = ["onClick", "onMouseover"]
const _hoisted_61 = ["onMouseover"]
const _hoisted_62 = ["onMouseover"]
const _hoisted_63 = {
  key: 2,
  src: _imports_31,
  alt: ""
}
const _hoisted_64 = ["onClick"]
const _hoisted_65 = { class: "beginTime" }
const _hoisted_66 = { class: "endTime" }
const _hoisted_67 = {
  key: 3,
  class: "rolesImgs"
}
const _hoisted_68 = ["onClick"]
const _hoisted_69 = ["src"]
const _hoisted_70 = ["src"]
const _hoisted_71 = ["onClick"]
const _hoisted_72 = {
  key: 2,
  class: "roleImgList"
}
const _hoisted_73 = { class: "roleImgListTitle" }
const _hoisted_74 = { class: "roleImgOneBox" }
const _hoisted_75 = { class: "roleImgOneBoxInner" }
const _hoisted_76 = ["onClick"]
const _hoisted_77 = ["src"]
const _hoisted_78 = ["src"]
const _hoisted_79 = { class: "tableListRight" }
const _hoisted_80 = { class: "captionsText" }
const _hoisted_81 = { class: "textcontainer" }
const _hoisted_82 = ["onClick"]
const _hoisted_83 = ["onUpdate:modelValue", "onInput", "onKeydown"]
const _hoisted_84 = { class: "textColor" }
const _hoisted_85 = {
  key: 0,
  class: "textcontainer"
}
const _hoisted_86 = ["onClick"]
const _hoisted_87 = ["onUpdate:modelValue", "onInput"]
const _hoisted_88 = { class: "textColor" }
const _hoisted_89 = { class: "captionsInfo" }
const _hoisted_90 = { class: "keyLength" }
const _hoisted_91 = { class: "textMessage" }
const _hoisted_92 = { class: "textMessageImg" }
const _hoisted_93 = ["onClick"]
const _hoisted_94 = { key: 0 }
const _hoisted_95 = { class: "textMessageImg" }
const _hoisted_96 = ["onClick"]
const _hoisted_97 = { key: 1 }
const _hoisted_98 = { class: "messagePageSend" }
const _hoisted_99 = ["src"]
const _hoisted_100 = ["src"]
const _hoisted_101 = {
  key: 0,
  class: "pageSendBox"
}
const _hoisted_102 = { class: "pageSendTop" }
const _hoisted_103 = { class: "pageSendTopLeft" }
const _hoisted_104 = ["src"]
const _hoisted_105 = ["src"]
const _hoisted_106 = { class: "pageSendBtm" }
const _hoisted_107 = {
  key: 0,
  class: "ttsPrompt"
}
const _hoisted_108 = ["onContextmenu"]
const _hoisted_109 = ["onClick"]
const _hoisted_110 = ["onClick"]
const _hoisted_111 = { class: "beginTime" }
const _hoisted_112 = { class: "endTime" }
const _hoisted_113 = {
  key: 1,
  class: "rolesImgs"
}
const _hoisted_114 = ["onClick"]
const _hoisted_115 = ["src"]
const _hoisted_116 = ["src"]
const _hoisted_117 = ["onClick"]
const _hoisted_118 = ["src"]
const _hoisted_119 = { class: "tableListRight" }
const _hoisted_120 = { class: "captionsText" }
const _hoisted_121 = { class: "textcontainer" }
const _hoisted_122 = {
  key: 0,
  class: "textcontainer"
}
const _hoisted_123 = ["onContextmenu", "onMouseover"]
const _hoisted_124 = ["onClick"]
const _hoisted_125 = ["onClick", "onMouseover"]
const _hoisted_126 = ["onMouseover"]
const _hoisted_127 = ["onMouseover"]
const _hoisted_128 = {
  key: 2,
  src: _imports_31,
  alt: ""
}
const _hoisted_129 = ["onClick"]
const _hoisted_130 = { class: "beginTime" }
const _hoisted_131 = { class: "endTime" }
const _hoisted_132 = {
  key: 3,
  class: "rolesImgs"
}
const _hoisted_133 = ["onClick"]
const _hoisted_134 = ["src"]
const _hoisted_135 = ["src"]
const _hoisted_136 = ["onClick"]
const _hoisted_137 = ["src"]
const _hoisted_138 = {
  key: 2,
  class: "roleImgList"
}
const _hoisted_139 = { class: "roleImgListTitle" }
const _hoisted_140 = { class: "roleImgOneBox" }
const _hoisted_141 = { class: "roleImgOneBoxInner" }
const _hoisted_142 = ["onClick"]
const _hoisted_143 = ["src"]
const _hoisted_144 = ["src"]
const _hoisted_145 = { class: "tableListRight" }
const _hoisted_146 = { class: "captionsText" }
const _hoisted_147 = { class: "textcontainer" }
const _hoisted_148 = ["onClick"]
const _hoisted_149 = ["onUpdate:modelValue", "onInput"]
const _hoisted_150 = { class: "textColor" }
const _hoisted_151 = {
  key: 0,
  class: "textcontainer"
}
const _hoisted_152 = ["onClick"]
const _hoisted_153 = ["onUpdate:modelValue", "onInput"]
const _hoisted_154 = { class: "textColor" }
const _hoisted_155 = { class: "captionsInfo" }
const _hoisted_156 = { class: "keyLength" }
const _hoisted_157 = { class: "textMessage" }
const _hoisted_158 = { class: "textMessageImg" }
const _hoisted_159 = ["onClick"]
const _hoisted_160 = { key: 0 }
const _hoisted_161 = { class: "textMessageImg" }
const _hoisted_162 = ["onClick"]
const _hoisted_163 = { key: 1 }
const _hoisted_164 = { class: "messagePageSend" }
const _hoisted_165 = ["src"]
const _hoisted_166 = ["src"]
const _hoisted_167 = {
  key: 0,
  class: "pageSendBox"
}
const _hoisted_168 = { class: "pageSendTop" }
const _hoisted_169 = { class: "pageSendTopLeft" }
const _hoisted_170 = ["src"]
const _hoisted_171 = ["src"]
const _hoisted_172 = { class: "pageSendBtm" }
const _hoisted_173 = {
  key: 0,
  class: "ttsPrompt"
}
const _hoisted_174 = { class: "videoRunBox" }
const _hoisted_175 = { class: "videoRunBoxInner" }
const _hoisted_176 = { class: "videoRunTop" }
const _hoisted_177 = { class: "videoRunLine" }
const _hoisted_178 = { class: "videoRunTime" }
const _hoisted_179 = { class: "videoRunBtm" }
const _hoisted_180 = { class: "videoRunBtnBox" }
const _hoisted_181 = { class: "videoRunBtnRight" }
const _hoisted_182 = {
  key: 0,
  class: "mask"
}
const _hoisted_183 = { class: "lodaing" }
const _hoisted_184 = {
  key: 1,
  class: "lodaing"
}
const _hoisted_185 = { class: "marketdelBox" }
const _hoisted_186 = {
  key: 2,
  class: "lodaing"
}
const _hoisted_187 = { class: "marketdelBox" }

import { timeInfo, timeInfominute, timedata } from '@/components/public-method/time-method';
import sliderPoint from '@/components/common/sliderPoint'
import { ElScrollbar } from 'element-plus';
// 引入页面图标
import { applicationDetail } from "@/views/captions/icon.ts";
import selectBox from "./selectBox.vue"
// 引入路由模块
import routerBox from "@/components/common/routerBox.vue"
// 引入我的模块
import mainBox from "@/components/common/mainBox.vue"
// 引入历史编辑
import historyEdit from "./historyEdit.vue"
// 弹窗模块
import simplified from "./simplified.vue"
import control from "./control.vue"
import shareBox from "./shareBox.vue"
import versionList from "./versionList.vue"
import roleEdit from "./roleEdit.vue"
import translate from "./translate.vue"
import videoAmplify from "./videoAmplify.vue"
import exports from "./export.vue"
import findReplace from "./findReplace.vue"
import uploadSrt from "./uploadSrt.vue"
import savePage from "./savePage.vue"
import allHistory from "./allHistory.vue"
import ttsPage from "./ttsPage.vue"
import ttsMultiple from "./ttsMultiple.vue"

// 引入下拉框
import menuPage from "@/components/common/menuPage.vue";
// 音轨模块引入
import waveCanvas from '@/views/captions/peak/waveCanvas.vue'
// 头部下拉列表
import type { CheckboxValueType } from 'element-plus'
import headPic from '@/assets/aivoice/ico_morentouxiang.svg';
import { uuid } from '@/components/public-method/getuuid';
import { ref, onMounted, getCurrentInstance, reactive, nextTick,watch,onUnmounted } from 'vue'
import {
    ArrowDown,
    ArrowUp,
    Delete,
    Close,
    Refresh,
} from "@element-plus/icons-vue";
import { ElMessage, ElMessageBox, ElLoading } from "element-plus";
import { useRouter ,useRoute} from 'vue-router';
// 引入删除提示
import delbox from "@/components/common/del.vue";
// 引入接口
import newCaptionApi from "@/api/newCaption/index.ts";
import ttsExportApi from "@/api/newCaption/ttsExport.ts";
import ttsOriginalApi from "@/api/newCaption/ttsOriginal.ts";
import ttsTranslationApi from "@/api/newCaption/ttsTranslation.ts";
import ttsOpenApi from "@/api/newCaption/ttsOpen.ts";
// 引入store
import {captionTtsStore} from "@/store/captionTts.ts"
const initColor='#409EFF'

export default /*@__PURE__*/_defineComponent({
  __name: 'captionsEdit',
  setup(__props) {

// 时间处理方法
const ttstore=captionTtsStore()
// ==========================tts============================//

const ismuted=ref(false)//原文件是否静音
const ttsUrl=ref('')//tts生成的音频地址
const ttsVideoRef=ref()//tts音频标签
const isTtsOpen=ref(false)//是否开启tts
const isTtsDubbing=ref(false)//是否开启tts译文配音
const isTtsHeightLight=ref(false)//是否高亮显示配音文本
const originalData=ref([])//原文tts数据
const dubbingData=ref([])//译文tts数据
const ttsStatus=ref(0)//tts状态 0无 1原文 2译文 
const isOpenttsTxt=ref(0)//tts打开列表状态 0排队 1进行中 100完成
watch(ttstore,(newVal,oldVal)=>{
    // isTtsOpen.value=newVal
   console.log('监听到tts变化'+newVal.isOpen)
   console.log(newVal)
    
    
    isTtsHeightLight.value=newVal.isHeightLight
    
    if(isTtsOpen.value && !newVal.isDubbing){
        ttsStatus.value=1 
    }else if(isTtsOpen.value && newVal.isDubbing){
        ttsStatus.value=2
    }else if(!newVal.isDubbing){
        ttsStatus.value=0
    }
    if(newVal.isOpen&&!isTtsOpen.value){
        ttsStatus.value=1
        
        isOpenttsFun()
        
    }
    isTtsOpen.value=newVal.isOpen
    // getTtsList()
    // console.log('isTtsDubbing.value'+newVal.isDubbing)
    // console.log('isTtsDubbing.value'+oldVal.isDubbing)
    if(newVal.isDubbing!=isTtsDubbing.value){//加载配音完成
        // ttsStatus.value=2
        
        if(isOpenttsTxt.value==100){
            isTtsDubbing.value=newVal.isDubbing
            getTtsList()
        }else if(isOpenttsTxt.value==0){
            ttsOpenApi.getTtsState(textId.value,2).then((res)=>{
                console.log('加载配音完成获取状态')
                console.log(res)
                
            })
        }

    }
})
// 打开tts获取状态
const  isOpenttsFun=()=>{
     ttsOpenApi.getTtsState(textId.value,0).then((res:any)=>{
        console.log('打开tts获取状态')
        console.log(res)
        isOpenttsTxt.value=res.data.translationStatus
        getTtsList()
        // ttstore.updateTranslationStatus(res.data.translationStatus)
        if(res.data.translationStatus==100||res.data.translationStatus==0){
            ttstore.loadState(false)
            
            
            
        }else{
            if(res.data.translationStatus==1){
                ttstore.loadState(true)
            }
            
        }
        // else{
        //     ttstore.loadState(true)
        // }
    })
}
// 获取字幕TTS列表
const getTtsList=()=>{  
    newCaptionApi.getTtsText(textId.value,ttsStatus.value).then((res:any)=>{
        console.log('获取字幕TTS列表')
        console.log(res)
        // if(ttsStatus.value==2){
        //     ttstore.loadState(false)
        //     // ttstore.dubbingOpen(true)
        // }
        if(res.code==200){
            editData.value=res.data
            captionTextOld.value = JSON.parse(JSON.stringify(res.data))
            ttstore.updatattsListData(res.data)
        }
       
    })
}
// 倍速
const setseepTime = ref()
const updateMultiple=(data:any)=>{
    console.log('倍速'+ttsMultipleIndex.value)
    clearTimeout(setseepTime.value)
    editData.value[ttsMultipleIndex.value].ttsAudio.speed = data
    setseepTime.value=setTimeout(()=>{
        console.log('修改倍速请求')
        ttsOpenApi.putTtsSpeed(textId.value,editData.value[ttsMultipleIndex.value].id,ttsStatus.value,data).then((res)=>{
            console.log('修改倍速返回结果')
            console.log(res)
            
        })
    },500)
    // setseeptime=setTimeout(()=>{
    //     console.log('修改倍速请求')
    // //     ttsOpenApi.putTtsSpeed(textId.value,editData.value[ttsMultipleIndex.value].id,ttsStatus.value,data).then((res)=>{
    // //         console.log('修改倍速返回结果')
    // //         console.log(res)
            
    // //     })
    // },500)
    
}
// 重新生成TTS
const reTtsDubbing=(item:any)=>{
    console.log('重新生成TTS'+item)
    ttsOpenApi.reTtsDubbing(textId.value,ttsStatus.value,item.id).then((res)=>{ 
        console.log(res)
    })
    
}
// 播放暂停方法
const audioRef=ref()
const playSettime=ref()
const playPause = () => {
    console.log('播放暂停'+startTime.value)
    if(textfilterShow.value){
        ElMessage({
            message: '请关闭显示筛选规则功能后播放',
            type: 'warning',
            duration: 2000
        });
        return
    }
    closeAll()
    // clickIndex.value = -1
    playShow.value = !playShow.value
    rePlatTextOff.value = false
    if (isMp4.value) {
        if (playShow.value) {
            videoRef.value.play()
            // runPlay()
        } else {
            // clearInterval(playSettime.value)
            videoRef.value.pause()
            ttsVideoRef.value.pause()
        }
    } else {
        if (playShow.value) {
            audioRef.value.play()
        } else {
            // clearInterval(playSettime.value)
            audioRef.value.pause()
            ttsVideoRef.value.pause()
        }
    }


};
// 定时播放

const runPlay=()=>{
    playSettime.value=setInterval(()=>{
        //  console.log('字幕滚动条移动-----------')
        startTime.value+=10
        let time=startTime.value
        updateTimeShow.value = startTime.value / 1000
        // 
        if(isTtsOpen.value){//播放TT文件
            isTtsDubbing.value?ismuted.value=true:ismuted.value=false
            let currentItem= editData.value.filter((item) => time >= item.beginTime && time <= item.endTime&&item.ttsAudio!=undefined)[0]
            if(currentItem!=undefined){
                // ismuted.value=true
                if(currentItem.ttsAudio.audio!=undefined&&currentItem.ttsAudio.audio!=ttsUrl.value){
                    ttsUrl.value=currentItem.ttsAudio.audio
                    // clearInterval(playSettime.value)
                }
                if(currentItem.ttsAudio.audio==undefined){
                    ttsVideoRef.value.pause()
                    // ismuted.value=false
                }
                // console.log(ttsUrl.value)
                ttsVideoRef.value.playbackRate=currentItem.ttsAudio.speed ||1.0
                if(playShow.value){
                    ttsVideoRef.value.play()     
                }else{
                    ttsVideoRef.value.pause()
                }      
            }else{
                ttsVideoRef.value.pause()
                // ismuted.value=false
            }

        }else{
            ismuted.value=false
        }
        // let runItem= editData.value.filter((item) => time >= item.beginTime && time <= item.endTime)[0]
        // if(runItem!=undefined){
        //     cnText.value = runItem.original.text
        //     if(runItem.translation!=undefined){
        //         enText.value = runItem.translation.text || ''
        //     }
        //     const idx = editData.value.findIndex(item=>time >= item.beginTime && time <= item.endTime)
        //     styleInde.value=idx
        //     if (clickIndex.value < 0) {
        //         // console.log('字幕滚动条移动'+index)
                
        //         // scrollAreaRef.value.scrollTop = (60 * (index - 3))
        //         scrollAreaRef.value!.setScrollTop(60 * (idx - 3))
        //     }
        // }else{
        //     cnText.value = ''
        //     enText.value = ''
        //     styleInde.value =-1 
        // }
        if (!rePlatTextOff.value) {
            cnText.value = ''
            enText.value = ''
            // console.log('字幕滚动条移动-----------')
            editData.value.forEach((item, index) => {
                if (time >= item.beginTime && time <= item.endTime) {
                    cnText.value = item.original.text
                    if(item.translation!=undefined){
                        enText.value = item.translation.text || ''
                        }
                    
                    // 字幕滚动条移动
                    if (clickIndex.value < 0) {
                        // console.log('字幕滚动条移动'+index)
                        
                        // scrollAreaRef.value.scrollTop = (60 * (index - 3))
                        scrollAreaRef.value!.setScrollTop(60 * (index - 3))
                    }
                    
                    styleInde.value = (index )
                    selPlayRange.runtime=startTime.value
                    selPlayRange.beginTime=item.beginTime
                    selPlayRange.endTime=item.endTime
                    selPlayRange.index=index
                }else if(index<(editData.value.length-1)&&index>=0){
                    if(time>item.endTime&& time<editData.value[index+1].beginTime){
                        // console.log('=============')
                        // scrollAreaRef.value.scrollTop = (60 * (index - 3))
                        scrollAreaRef.value!.setScrollTop(60 * (index - 3))
                        styleInde.value =-1
                        selPlayRange.runtime=editData.value[index].endTime
                        cnText.value =''
                        if(editData.value[index].translation!=undefined){
                            enText.value =  ''
                        }
                        // styleInde.value = (index )
                        // cnText.value = editData.value[index].original.text
                        // if(editData.value[index].translation!=undefined){
                        //     enText.value = editData.value[index].translation.text || ''
                        // }
                        
                    }
                }

            })
            
        }else{
            // console.log('字幕滚动条移动=======')
            // 重复播放时进度条
            selPlayRange.runtime=startTime.value
            if(rePlatTextOff.value&&!playShow.value){
                selPlayRange.runtime=selPlayRange.endTime
            }
            styleInde.value =-1
            editData.value.forEach((item, index) => {
                if (time >= item.beginTime && time <= item.endTime) {
                    cnText.value = item.original.text
                    if(item.translation!=undefined){
                        enText.value = item.translation.text || ''
                    }
                    styleInde.value=index
                }
            })

        }

    },10)
}
onUnmounted(()=>{
    console.log('===========推出页面======================')
    videoRef.value?.pause()
    ttsVideoRef.value?.pause()
    clearInterval(playSettime.value) 
    audioRef.value.currentTime=0
})
// 视频播放
const updateCurren= (event: any) => {
    console.log('字幕滚动条移动')
    console.log(event.target.currentTime)
    if(rePlatTextOff.value){
        return
    }
    let time=event.target.currentTime*1000
    if (Math.abs(time - startTime.value*1) >= 100) {
        startTime.value=Math.ceil(time)
        updateTimeShow.value =startTime.value/ 1000
    }
}
const updateCurrentTime = (event: any) => {
    console.log('字幕滚动条移动')
        startTime.value=Math.ceil(event.target.currentTime*1000)
        console.log('字幕滚动条移动'+startTime.value)
        let time=startTime.value
        updateTimeShow.value = startTime.value / 1000
        // 
        if(isTtsOpen.value){//播放TT文件
            isTtsDubbing.value?ismuted.value=true:ismuted.value=false
            let currentItem= editData.value.filter((item) => time >= item.beginTime && time <= item.endTime&&item.ttsAudio!=undefined)[0]
            if(currentItem!=undefined){
                // ismuted.value=true
                if(currentItem.ttsAudio.audio!=undefined&&currentItem.ttsAudio.audio!=ttsUrl.value){
                    ttsUrl.value=currentItem.ttsAudio.audio
                    // clearInterval(playSettime.value)
                }
                if(currentItem.ttsAudio.audio==undefined){
                    ttsVideoRef.value.pause()
                    // ismuted.value=false
                }
                // console.log(ttsUrl.value)
                ttsVideoRef.value.playbackRate=currentItem.ttsAudio.speed ||1.0
                if(playShow.value){
                    ttsVideoRef.value.play()     
                }else{
                    ttsVideoRef.value.pause()
                }      
            }else{
                ttsVideoRef.value.pause()
                // ismuted.value=false
            }

        }else{
            ismuted.value=false
        }
        // let runItem= editData.value.filter((item) => time >= item.beginTime && time <= item.endTime)[0]
        // if(runItem!=undefined){
        //     cnText.value = runItem.original.text
        //     if(runItem.translation!=undefined){
        //         enText.value = runItem.translation.text || ''
        //     }
        //     const idx = editData.value.findIndex(item=>time >= item.beginTime && time <= item.endTime)
        //     styleInde.value=idx
        //     if (clickIndex.value < 0) {
        //         // console.log('字幕滚动条移动'+index)
                
        //         // scrollAreaRef.value.scrollTop = (60 * (index - 3))
        //         scrollAreaRef.value!.setScrollTop(60 * (idx - 3))
        //     }
        // }else{
        //     cnText.value = ''
        //     enText.value = ''
        //     styleInde.value =-1 
        // }
        if (!rePlatTextOff.value) {
            cnText.value = ''
            enText.value = ''
            // console.log('字幕滚动条移动-----------')
            editData.value.forEach((item, index) => {
                if (time >= item.beginTime && time <= item.endTime) {
                    cnText.value = item.original.text
                    if(item.translation!=undefined){
                        enText.value = item.translation.text || ''
                        }
                    
                    // 字幕滚动条移动
                    if (clickIndex.value < 0) {
                        // console.log('字幕滚动条移动'+index)
                        
                        // scrollAreaRef.value.scrollTop = (60 * (index - 3))
                        scrollAreaRef.value!.setScrollTop(60 * (index - 3))
                    }
                    
                    styleInde.value = (index )
                    selPlayRange.runtime=startTime.value
                    selPlayRange.beginTime=item.beginTime
                    selPlayRange.endTime=item.endTime
                    selPlayRange.index=index
                }else if(index<(editData.value.length-1)&&index>=0){
                    if(time>item.endTime&& time<editData.value[index+1].beginTime){
                        // console.log('=============')
                        // scrollAreaRef.value.scrollTop = (60 * (index - 3))
                        scrollAreaRef.value!.setScrollTop(60 * (index - 3))
                        styleInde.value =-1
                        selPlayRange.runtime=editData.value[index].endTime
                        cnText.value =''
                        if(editData.value[index].translation!=undefined){
                            enText.value =  ''
                        }
                        // styleInde.value = (index )
                        // cnText.value = editData.value[index].original.text
                        // if(editData.value[index].translation!=undefined){
                        //     enText.value = editData.value[index].translation.text || ''
                        // }
                        
                    }
                }

            })
            
        }else{
            // console.log('字幕滚动条移动=======')
            // 重复播放时进度条
            selPlayRange.runtime=startTime.value
            if(rePlatTextOff.value&&!playShow.value){
                selPlayRange.runtime=selPlayRange.endTime
            }
            styleInde.value =-1
            editData.value.forEach((item, index) => {
                if (time >= item.beginTime && time <= item.endTime) {
                    cnText.value = item.original.text
                    if(item.translation!=undefined){
                        enText.value = item.translation.text || ''
                    }
                    styleInde.value=index
                }
            })

        }


}
// 重复播放该字幕
const selPlayRange=reactive({
    beginTime:0,
    endTime:0,
    runtime:0,
    index:0
})
const timeOutFun=ref()
const rePlatText = (item: any, index: number) => {
    console.log(item)
    if(timeOutFun.value!=null){
        clearTimeout(timeOutFun.value)
        timeOutFun.value=null
    }
    // playShow.value = true
    // playPause()
    startTime.value=item.beginTime
    updateTimeShow.value=item.beginTime/1000
    clickIndex.value = index
    editTextIndex.value = -1
    // console.log('重复播放该字幕index' +index)
    waveChild.value.rePlatText(item.beginTime)
    const timeout = item.endTime - item.beginTime
    cnText.value = item.original.text
    if(item.translation!=undefined){
        enText.value = item.translation.text || ''
    }
    // lnineToTimeUp(item.beginTime/1000)
    // playShow.value = false
    // playPause()
    // rePlatTextOff.value = true
    // console.log('播放时间'+timeout)
    // timeOutFun.value=setTimeout(() => {
    //     console.log('播放时间'+startTime.value)
    //     startTime.value=item.endTime
    //     clearInterval(playSettime.value)
    //     updateTimeShow.value=item.endTime/1000
    //     videoRef.value?.pause()
    //     ttsVideoRef.value?.pause()
    //     audioRef.value?.pause()
    //     playShow.value = false
    //     lnineToTimeUp(item.endTime/1000)
    //     // playShow.value = true
    //     // playPause()
    // }, timeout);

    //播放
    styleInde.value = clickIndex.value
    playShow.value = true
    rePlatTextOff.value = true

    selPlayRange.beginTime=item.beginTime
    selPlayRange.endTime=item.endTime
    selPlayRange.index=index
    // 视频播放跳转
    if (isMp4.value) {
        videoRef.value.currentTime = (item.beginTime / 1000)
        if (playShow.value) {
            // videoRef.value.currentTime=(item.beginTime/1000)
            if(isTtsOpen.value&&item.ttsAudio!=undefined){
                ttsUrl.value=item.ttsAudio.audio
                ismuted.value=true
                ttsVideoRef.value.play()
            }
           
            videoRef.value.play()
            
           
            timeOutFun.value=setTimeout(() => {
                
                playShow.value = false
                updateTimeShow.value=item.endTime/1000
                selPlayRange.runtime=item.endTime
                videoRef.value.pause()
                ttsVideoRef.value.pause()
                // clearInterval(playSettime.value)
                // playShow.value=false
                lnineToTimeUp(updateTimeShow.value)
                console.log('结束时间'+updateTimeShow.value)
            }, timeout);
        } else {
            selPlayRange.runtime=item.endTime
            videoRef.value.pause()
            ttsVideoRef.value.pause()
        }
    } else {
        audioRef.value.currentTime = (item.beginTime / 1000)
        if (playShow.value) {
            // videoRef.value.currentTime=(item.beginTime/1000)
            if(isTtsOpen.value&&item.ttsAudio!=undefined){
                ttsUrl.value=item.ttsAudio.audio
                ismuted.value=true
                ttsVideoRef.value.play()
            }
            
            audioRef.value.play()
            timeOutFun.value=setTimeout(() => {
                audioRef.value.pause()
                ttsVideoRef.value.pause()
                playShow.value = false
                updateTimeShow.value=item.endTime/1000
                selPlayRange.runtime=item.endTime
                selPlayRange.endTime=item.endTime
                lnineToTimeUp(updateTimeShow.value)
                console.log('结束时间'+updateTimeShow.value)
            }, timeout);
        } else {
            selPlayRange.runtime=item.endTime
            audioRef.value.pause()
            ttsVideoRef.value.pause()
        }
    }
    
    if(isTtsOpen.value){
        ttsVideoRef.value.currentTime=0
    }
    

}
// 标线跳转
const lnineToTimeUp = (time: number) => {
    console.log('标线跳转' + time)
    // timesLider.value = time * 100000 / totalTime.value
    startTime.value = time*1000
    updateTimeShow.value = time
    cnText.value = ''
    enText.value = ''

    if (!rePlatTextOff.value) {
        editData.value.forEach((item, index) => {
            if (startTime.value >= item.beginTime && startTime.value <= item.endTime) {
                cnText.value = item.original.text
                if(item.translation!=undefined){
                    enText.value = item.translation.text || ''
                    }
                
                // 字幕滚动条移动
                if (clickIndex.value < 0) {
                    // console.log('字幕滚动条移动'+index)
                    
                    // scrollAreaRef.value.scrollTop = (60 * (index - 3))
                    scrollAreaRef.value!.setScrollTop(60 * (index - 3))
                }
                
                styleInde.value = (index )
                selPlayRange.runtime=time*1000
                selPlayRange.beginTime=item.beginTime
                selPlayRange.endTime=item.endTime
                selPlayRange.index=index
            }else if(index<(editData.value.length-1)&&index>0){
                if(startTime.value>item.endTime&& startTime.value<editData.value[index+1].beginTime){
                    // console.log('=============')
                    // scrollAreaRef.value.scrollTop = (60 * (index - 3))
                    scrollAreaRef.value!.setScrollTop(60 * (index - 3))
                    styleInde.value = -1
                    selPlayRange.runtime=editData.value[index].endTime
                    cnText.value = ''
                    enText.value = ''
                    
                }
            }

        })
        
    }else{
        // 重复播放时进度条
        selPlayRange.runtime=time*1000
        if(rePlatTextOff.value&&!playShow.value){
            selPlayRange.runtime=selPlayRange.endTime
        }

    }
    // 视频跳转
  
    if (isMp4.value) {
        console.log('跳转时间'+time)
        videoRef.value.currentTime  = time*1
    } else {
        console.log('跳转时间'+time)
        audioRef.value.currentTime  = time*1
    }
    // tts跳转
    if(isTtsOpen.value&&!isTtsDubbing.value){
        let currentItem= editData.value.filter((item) => time*1000 >= item.beginTime && time*1000 <= item.endTime&&item.ttsOriginalData!=undefined)[0]
        if(currentItem!=undefined){
             ismuted.value=true
            let goTime=(time*1000 - currentItem.beginTime)/1000
            console.log('跳转tts时间'+goTime)   
                if(ttsUrl.value!=currentItem.ttsOriginalData.audio){
                    ttsUrl.value=currentItem.ttsOriginalData.audio
                }
                nextTick(()=>{
                    ttsVideoRef.value.currentTime=goTime
                })
                console.log(ttsUrl.value)
            //  ttsVideoRef.value.play()     
          }
     }
}
const handleTimeUpdate=(event:any)=>{
    console.log('tts时间更新'+event.target.currentTime)
    // runPlay()
}
// ==========================tts============================//
const menuShow=ref(false)
const selectRef=ref()
const ttsPageRef=ref()
// 删除提示弹窗
const opendelShow=ref(false)
const delText=ref('删除该项目，且永久不可恢复，确认删除？')
const router = useRouter();
const route=useRoute()
const subtitleId = ref()
const overThisRow=ref(-1)//鼠标移上显示备注
const predefineColors =[
  '#ff4500',
  '#ff8c00',
  '#ffd700',
  '#90ee90',
  '#00ced1',
  '#1e90ff',
  '#c71585',
]

let { proxy } = getCurrentInstance()
const changePage=ref(false)
watch(route, (to, from) => {
    // console.log('路由检测'+router.currentRoute.value.query.subtitleId)
    // console.log(to) 
    ttstore.toInit() 
    textLarge.value=false
    dataOrChange.value=[]
    showlodaing.value=true
    changePage.value=false
    updateTimeShow.value=0
    startTime.value=0
    clearInterval(playSettime.value) 
    closeAll()
    nextTick(()=>{
        if(router.currentRoute.value.query.subtitleId!=undefined){
            console.log('切换数据')
            // router.push({ path: '/index/aiApply/captionsEdit', query: { subtitleId: router.currentRoute.value.query.subtitleId } })
            subtitleId.value=router.currentRoute.value.query.subtitleId
            init()
        }
    })
 
})
const isOpenTtsDown=ref(false)//是否打开tts下载
const openttsDown=(data:any)=>{
    isOpenTtsDown.value=data
}
// 是否打开TTs
const controlTts=ref(false)//默认关闭TTs
// 倍速
const ttsMultipleIndex=ref(-1)
const mainImg=ref()
onMounted(() => {
    mainImg.value=JSON.parse(localStorage.getItem('user')).user
    subtitleId.value = router.currentRoute.value.query.subtitleId;
    console.log('空格播放暂停')
    showlodaing.value=true
    changePage.value=false
    init()
    // 空格播放暂停
    document.addEventListener('keydown', (event) => {
        // console.log(router.currentRoute.value)
        console.log('按下了键盘按钮：', event.code);
    if (event.code === 'Space' && router.currentRoute.value.path=='/index/aiApply/captionsEdit') {
          // 获取当前聚焦的元素
      const activeElement = document.activeElement;
      
      // 定义需要允许输入空格的元素类型
      const isInputElement = 
        activeElement.tagName === 'INPUT' ||
        activeElement.tagName === 'TEXTAREA' ||
        activeElement.isContentEditable;
      
      // 如果在可输入元素中，允许空格键正常输入
      if (isInputElement) {
        // 不阻止默认行为，让空格正常输入
        return;
      }
        event.preventDefault()
        // if(editTextIndexType.value!=''||showMessageIndex.value!=-1||roleImgShow.value||findReplaceShow.value||showSavePage.value){
        //     return
        // }
      playPause();
    }
    if (event.code === 'ArrowUp' && router.currentRoute.value.path=='/index/aiApply/captionsEdit') {
        event.preventDefault()
        console.log(editTextIndexType.value,showMessageIndex.value)
        // if(editTextIndexType.value!=''||showMessageIndex.value!=-1||findReplaceShow.value||showSavePage.value){
        //     return
        // }
        afterPlay();
    }
    if (event.code === 'ArrowDown' && router.currentRoute.value.path=='/index/aiApply/captionsEdit') {
        event.preventDefault()
        // if(editTextIndexType.value!=''||showMessageIndex.value!=-1||findReplaceShow.value||showSavePage.value){
        //     return
        // }
        nextPlay();
    }
    if (event.code === 'Backspace' && router.currentRoute.value.path=='/index/aiApply/captionsEdit'&&editTextIndex.value==-1&& !isOpenTtsDown.value&&!exportShow.value&&!findReplaceShow.value&&!ruleShow.value) {
        event.preventDefault()
        console.log('删除字幕')
        if(busyRefShow.value){
            busyDelFun( )
        }
    }
  });

})
const exportShow=ref(false)
const exportOpen=()=>{
    closeAll()
    exportShow.value=true
}
const changeSelect=(e:any)=>{
    cnText.value = ''
    enText.value = ''
    router.push({ path: '/index/aiApply/captionsEdit', query: { subtitleId: e } })
    subtitleId.value=e
    // init()
}
// =======================头部功能按键============================//
// 保存
const showSavePage=ref(false)
const funSave=()=>{
    showSavePage.value=true
    // ElMessage.success("字幕保存成功!");
}
// 撤销
const dataList = ref([])//缓存数据
const dataOrChange = ref([])//数据改变以及原始数据
const oldIndexData = ref()
const newIndexData = ref()
const indexOfChange = ref(-1)
const changeType = ref('')
const revokeindex = ref(-1)
const onOffrevoke = ref(false)
const captionTextOld = ref()//字幕列表历史数据
// 重置撤销还原参数
const resetRevoke = () => {
    dataOrChange.value = []
    revokeindex.value = -1
    onOffrevoke.value = false
}
const revoke = () => {
   
    if (revokeindex.value == -1 && !onOffrevoke.value) {
        revokeindex.value = (dataOrChange.value.length - 1)
        onOffrevoke.value = true
    }
    if (dataOrChange.value.length == 0 || (revokeindex.value == -1 && onOffrevoke.value)) {
        console.log('最后一项了')
        return
    }
    console.log('撤销')
    console.log(revokeindex.value)
    // console.log(captionTextOld.value)
    console.log(dataOrChange.value)
    const revokeType = dataOrChange.value[revokeindex.value].type
    const revokeData = dataOrChange.value[revokeindex.value]
    console.log(revokeType)
    if (revokeType == 'cn' || revokeType == 'en') {
        revokeText(revokeType, revokeData, 'revoke')
    } else if (revokeType == 'delText') {
        console.log('撤销删除+++++++++++')
        console.log(revokeData)
        revokeDel(revokeData,'revoke')
    } else if (revokeType == 'splitText') {
        
        revokeAddText(revokeData, 'revoke')
    } else if (revokeType == 'mergeText') {
        revokeMergeText(revokeData, 'revoke')
    }
    else  if(revokeType=='textboxMove'){
        // console.log('撤销字幕移动')
        revokeTextMove(revokeData,'revoke')
    }
    else if(revokeType=='textleftLine'){
        console.log('撤销字幕向左拉伸')
        revokelineMove(revokeData,'revoke','textleftLine')
    }
    else if(revokeType=='textrightLine'){
        console.log('撤销字幕向左拉伸')
        revokelineMove(revokeData,'revoke','textrightLine')
    }else if(revokeType=='cnColor'){
        console.log('撤销字幕颜色')
        revokeCncolor(revokeData,'revoke')
    }else if(revokeType=='enColor'){
        console.log('撤销字幕颜色')
        revokeEncolor(revokeData,'revoke')
    }else if(revokeType=='toReplaceoriginal'||revokeType=='toReplacetranslation'){
        console.log('撤销替换单个')
        revokeReplaceOne(revokeData,'revoke')
    }else if(revokeType=='ListReplaceoriginal'||revokeType=='ListReplacetranslation'){
        console.log('撤销替换批量')
        revokeReplaceList(revokeData,'revoke')
    }else if(revokeType=='splitTextEnter'){
        console.log('撤销回车替换')
        revokeEnterList(revokeData,'revoke')
    }

}
// 恢复
const restores = () => {
    console.log('恢复')
    
    // console.log(dataOrChange.value)
    if (revokeindex.value < dataOrChange.value.length - 1) {
        revokeindex.value += 1
    }
    console.log(revokeindex.value)
    console.log(dataOrChange.value.length)
    if (dataOrChange.value.length == 0 || revokeindex.value > dataOrChange.value.length) {
        console.log('最后一项了')
        return
    }

    const revokeType = dataOrChange.value[revokeindex.value].type
    const revokeData = dataOrChange.value[revokeindex.value]
    console.log(revokeData)
    if (revokeType == 'cn' || revokeType == 'en') {
        revokeText(revokeType, revokeData, 'restore')
    } else if (revokeType == 'delText') {
        revokeDel(revokeData,'restore')
    }
    else if (revokeType == 'splitText') {
        revokeAddText(revokeData, 'restore')
    } else if (revokeType == 'mergeText') {
        revokeMergeText(revokeData, 'restore')
    }
    else  if(revokeType=='textboxMove'){
        revokeTextMove(revokeData,'restore')
    }
    else if(revokeType=='textleftLine'){
        revokelineMove(revokeData,'restore','textleftLine')
    }
    else if(revokeType=='textrightLine'){
        revokelineMove(revokeData,'restore','textrightLine')
    }else if(revokeType=='cnColor'){
        console.log('撤销字幕颜色')
        revokeCncolor(revokeData,'restore')
    }else if(revokeType=='enColor'){
        console.log('撤销字幕颜色')
        revokeEncolor(revokeData,'restore')
    }else if(revokeType=='toReplaceoriginal'||revokeType=='toReplacetranslation'){
        console.log('撤销替换单个')
        revokeReplaceOne(revokeData,'restore')
    }else if(revokeType=='ListReplaceoriginal'||revokeType=='ListReplacetranslation'){
        console.log('撤销替换批量')
        revokeReplaceList(revokeData,'restore')
    }else if(revokeType=='splitTextEnter'){
        console.log('撤销回车替换')
        revokeEnterList(revokeData,'restore')
    }


}
// 简繁转换显示
const simplifiedShow = ref(false)
const simplifiedFun = () => {
    closeAll()
    simplifiedShow.value = true
}
// 展示翻译模块
const translateBoxShow = ref(false)
const translateBoxFun = () => {
    closeAll()
    translateBoxShow.value = true
    dataOrChange.value=[]
}
// 隐藏、显示译文
const translatShow=ref(false)//是否展示字幕
const deltranslatShow=ref(false)//是否删除字幕
const hidetranslat = () => {
    translatShow.value = !translatShow.value
    waveChild.value.hidetranslat([translatShow.value])
    dataOrChange.value=[]
    // resetRevoke()
 }
// 检查规则弹窗显示
const ruleShow = ref(false)
const controlFun = () => {
    closeAll()
    ruleShow.value = true
}
// 检查字幕弹窗显示
const textinspectShow = ref(false)
const styleinspectRule = {
    color: 'rgba(255, 54, 61, .6)',
}
const textinspectFun = () => {
    textinspectShow.value = !textinspectShow.value 
}
// 查找替换
const findReplaceShow=ref(false)
const findReplaceFun=()=>{
    findReplaceShow.value=true
    replaceIndex.value=-1
    scrollPlaceRef.value!.setScrollTop(0)
    playShow.value=false
    filterList.value=JSON.parse(JSON.stringify(editData.value))
    if (isMp4.value) {
        videoRef.value.pause()
    } else {
        audioRef.value.pause()
    }

}
// 替换文字
const replaceWordFun=(data:any)=>{
    // console.log(data)
    dataOrChange.value.push(JSON.parse(data))
}
// 上一条，下一条
const replaceIndex=ref(-1)
const scrollPlaceRef=ref()
const showTxtThis=(data:any)=>{
    // console.log(data)
    replaceIndex.value=filterList.value.findIndex(item=>item.id==JSON.parse(data))
    scrollPlaceRef.value!.setScrollTop(60 * (replaceIndex.value - 3))
    // console.log(replaceIndex.value)
}
// 显示匹配字幕
const filterList=ref()
const filterListFun=(data:any)=>{
    // console.log(data)
    const languageTxt=data[2]
    if(data[0]){//true
        if(languageTxt=='cn'){
            filterList.value=JSON.parse(JSON.stringify(editData.value.filter(it=>it.original.text.indexOf(data[1])!=-1)))
        }else{
            filterList.value=JSON.parse(JSON.stringify(editData.value.filter(it=>it.translation.text.indexOf(data[1])!=-1)))
        }
    }else{
        filterList.value=JSON.parse(JSON.stringify(editData.value))
    }
}
// 上传srt
const uploadSrtShow=ref(false)
const uploadSrtFun=()=>{
    uploadSrtShow.value=true
}
// 重新加载字幕
const reSrtText=()=>{
    uploadSrtShow.value=false
    init()
}
// 角色头像展示
const roleImgShow = ref(false)
const overRole=ref(-1)
const leftBorder = {
    'border': '1px solid #26272B'
}
const noBorder = {
    'border': 'none'
}
const roleImgFun = () => {
    roleImgShow.value = !roleImgShow.value
}
// 时间码展示
const timeBoxShow = ref(true)
const timeBoxFun = () => {
    timeBoxShow.value = !timeBoxShow.value
}
// 所有历史编辑记录
const allHistoryShow=ref(false)
//subtitleLogsAll 所有修改文件
const funEditAll=()=>{
    closeAll()
    allHistoryShow.value=true
}

// 历史编辑模块展示
const historyEditShow = ref(false)





// 分享弹窗展示
const shareBoxShow = ref(false)
const shareBoxFun = () => {
    closeAll()
    shareBoxShow.value = !shareBoxShow.value
}
// 版本弹窗展示
const versionBoxShow = ref(false)
const versionBoxFun = () => {
    closeAll()
    versionBoxShow.value = !versionBoxShow.value
    // console.log('版本弹窗展示'+textId.value)
}

// =======================头部功能按键============================//
// =======================底部播放功能============================//
// 字幕放大
const textSize=ref(12)
const textEnlarge = () =>{
    console.log('字幕放大')
    if(textSize.value<=26){
        textSize.value++
    }
}
const textShrink = () =>{
    if(textSize.value>=10){
        textSize.value--
    }
}
// 字幕显示隐藏
const textShow=ref(true)
const textToshow = () =>{
    textShow.value=true
}
const textTohide = () =>{
    textShow.value=false
}
// =======================底部播放功能============================//




// 字幕文本
const cnText=ref('')
const enText=ref('')
const value = ref<CheckboxValueType[]>([])
const cities = ref([
    {
        value: 'Beijing',
        label: 'Beijing',
    }
])
// 查看标注
const showMessageIndex = ref(-1)
const comments = ref([])
const commentsType=ref('')
const commentsTypeDel=ref('')
const showMessage = (index: number, type: string, item: object) => {
    closeAll()
    comments.value = []
    contentSend.value=""
    showMessageIndex.value = index
    if (type == 'cn') {
        item.original.comments != undefined ? comments.value = item.original.comments : comments.value = []
        commentsType.value="addOriginalComment"
        commentsTypeDel.value='deleteOriginalComment'
        comments.value=item.original.comments ||[]
    } else {
        item.translation.comments != undefined ? comments.value = item.original.comments : comments.value = []
        commentsType.value="addTranslationComment"
        commentsTypeDel.value='deleteTranslationComment'
        comments.value=item.translation.comments || []
    }

}
const contentSend = ref('')
// 发送评论
const sendMsg = (id: string, index: number, type: string) => {
    if(contentSend.value=='') return
    editFunctionReplay({ content: contentSend.value }, id, index, commentsType.value)
}
// 删除评论
const delMsg = (id: string, index: number, commentId: string) => {
   newCaptionApi.putEditCaption(textId.value, { commentId: commentId }, id, index, commentsTypeDel.value,ttsStatus.value).then(res => {
        if (res.code == 200) {
            showMessageIndex.value = -1
        }
    })
}
// 初始化加载所有版本、初始化字幕详情；默认选择第一个版本信息
const initData = ref()//初始化字幕详情
const editData = ref()//字幕详情
const versionS = ref()//版本信息列表
const language = ref("")//语言
const textId = ref()
const initTitle = ref('')
const shareUsers = ref([])//分享人物
const subtitleLogsAll = ref([])//所有修改记录
const aUrl=ref('')//音视频播放地址
const isMp4=ref(false)//是否为视频播放
const selVersionName=ref('')
const isMy=ref(false)
const translationLanguage=ref('')
const init = () => {
    isOpenTtsDown.value=false
    styleInde.value=0
    overThisRow.value=-1
    cities.value=JSON.parse(localStorage.getItem('projectoften'))||[]
    demoData.canvasWidth = waveWidthRef.value.clientWidth
    waveBoxIidth.value = waveWidthRef.value.clientWidth
    cnText.value = ''
    enText.value = ''
    textLarge.value=false
    dataOrChange.value=[]
    editData.value=[]
    showlodaing.value=true
    changePage.value=false
    updateTimeShow.value=0
    playShow.value=false
    isTtsDubbing.value=false
	isTtsOpen.value=false
    scrollAreaRef.value!.setScrollTop(0)
    ttstore.toInit()
    startTime.value=0
    clearInterval(playSettime.value)
    aUrl.value=''
    newCaptionApi.getInitCaption(subtitleId.value).then((res) => {
        console.log(res)
        initData.value = res.data
        // editId.value = res.data.subtitleId
        demoData.subtitleId = res.data.subtitleId
        demoData.duration= res.data.duration
        initTitle.value = res.data.title
        // 获取规则
        if (res.data.checkRule != null || res.data.checkRule != undefined) {
            checkRule.value = {...checkRule.value, ...res.data.checkRule}
        }
       
        
        // 分享人物
        shareUsers.value = res.data.shareUsers
        // 
        const fileType = res.data.fileName.split('.')[1]
        // console.log(fileType)
        isMp4.value = res.data.mp4Path != undefined;
       
        totalTime.value = (res.data.duration *1)
        console.log('总时长'+totalTime.value)
        //aUrl.value = res.data.fileUrl
        aUrl.value = res.data.mp4Path != undefined ?  res.data.mp4Path :  res.data.wavPath
        
       
        if (isMp4.value) {
            if(videoRef.value?.pause()){
                videoRef.value.pause()
                videoRef.value.currentTime  = 0
            }
            
        } else {
            if(audioRef.value?.pause()){
                audioRef.value.pause()
                audioRef.value.currentTime  = 0
            }
            // audioRef.value.pause()
            // audioRef.value.currentTime  = 0
        }
        // 
        
    })
    newCaptionApi.getCaptionVersion(subtitleId.value).then((res) => {
        // console.log(res)
        versionS.value = res.data
        textId.value = res.data[0].textId
        demoData.id = res.data[0].textId
        selVersionName.value= res.data[0].version
        getTtsRolesData()
        ttstore.updataTextId(res.data[0].textId)
        newCaptionApi.getEditCaption(subtitleId.value,res.data[0].textId).then((res) => {
            // console.log('=========')
              // 判断是否是自己发布
            const user = JSON.parse(localStorage.getItem('user'))
            user.user.id==res.data[0].userId?isMy.value=true:isMy.value=false
            // console.log(res.data[0].userId)
            editData.value = res.data[0].subtitles
            roleListBox.value = res.data[0].roles || []
            ttstore.updataRoleList(roleListBox.value)
            if(editData.value[0].original.text==undefined){
                editData.value[0].original.text=''
            }
            captionTextOld.value = JSON.parse(JSON.stringify(res.data[0].subtitles))
            // 判断是否有翻译
             translatShow.value = (editData.value.filter(item =>(item.translation!=undefined&&item.translation.text != undefined&&item.translation.text!='')).length>0) ? true : false
            deltranslatShow.value = (editData.value.filter(item =>(item.translation!=undefined&&item.translation.text != undefined&&item.translation.text!='')).length>0) ? true : false
            language.value = res.data[0].language
            ttstore.updataTranslatState(deltranslatShow.value)
            translationLanguage.value = res.data[0].translationLanguage
            subtitleLogsAll.value = res.data[0].subtitleLogs||[]
            editData.value.forEach(item => {
                item.isPlay=false
            });


            // console.log(editData.value)
            // 加载音轨
            initPeaks(subtitleId.value)
            showlodaing.value=false
        })
        
    })


}
onMounted(() => {
  document.addEventListener("click", (event) => {
    console.log(event);
    closeAll();
  });
});
const routerBoxref=ref()
const mainBoxRef=ref()
// 关闭所有弹窗
const closeAll = () => {
    versionBoxShow.value = false
    // versionBoxShow.value = true
    ruleShow.value = false
    simplifiedShow.value = false
    roleImgBoxShow.value = false
    translateBoxShow.value = false
    busyRefShow.value = false
    historyEditShow.value = false
    editTextIndex.value=-1
    showMessageIndex.value=-1
    editTextIndexType.value =''
    shareBoxShow.value=false
    exportShow.value=false
    allHistoryShow.value=false
    uploadSrtShow.value=false
    findReplaceShow.value=false
    mainBoxRef.value?.closes();
    selectRef.value?.closes();
    ttsMultipleIndex.value=-1
    ttsPageRef.value?.closeMenu();
}
// 选择版本
const versionSel = (id: number) => {
    closeAll()
    console.log('选择版本'+id)
    if (textId.value != id) {
        styleInde.value=0
        overThisRow.value=-1
        cnText.value = ''
        enText.value = ''
        textLarge.value=false
        showlodaing.value=true
        changePage.value=false
        updateTimeShow.value=0
        playShow.value=false
        dataOrChange.value=[]
        textId.value=id
        ttstore.updataTextId(id)
        scrollAreaRef.value!.setScrollTop(0)
        if (isMp4.value) {
            if(videoRef.value?.pause()){
                videoRef.value.pause()
                videoRef.value.currentTime  = 0
            }
            
        } else {
            if(audioRef.value?.pause()){
                audioRef.value.pause()
                audioRef.value.currentTime  = 0
            }
            // audioRef.value.pause()
            // audioRef.value.currentTime  = 0
        }
        selVersionName.value=versionS.value.filter(item=>item.textId==id)[0].version
        newCaptionApi.getEditCaption(subtitleId.value,id).then((res) => {
            console.log(res)
            const user = JSON.parse(localStorage.getItem('user'))
            user.user.id==res.data[0].userId?isMy.value=true:isMy.value=false
            editData.value = res.data[0].subtitles
            if(editData.value[0].original.text==undefined){
                editData.value[0].original.text=''
            }
            roleListBox.value = res.data[0].roles || []
            ttstore.updataRoleList(res.data[0].roles || [])
            demoData.id=id
            showlodaing.value=false
            editData.value.forEach(item => {
                item.isPlay=false
            });
           
        })
    }

}
 // 重新获取版本列表
 const getVersionList=()=>{
    dataOrChange.value=[]
    newCaptionApi.getCaptionVersion(subtitleId.value).then((res) => {
        // console.log(res)
        versionS.value = res.data
        selVersionName.value=versionS.value[0].version
        versionSel(res.data[0].textId)
        // demoData.id = res.data[0].textId
        // styleInde.value=-1
        // startTime.value=0
    })
}


// 新增角色
const roleListBox = ref([
    {
        avatar: "/upload/2025/01/11/b677613625344fdeb5c084dc4464c2a4.jpg",
        id: "5f9f0b44-4075-9e70-a439-419a7c77aef3",
        name: "1"
    }
])
const addRoleBox = () => {
    const obj = {
        "id": uuid(),
        "name": "新增角色"
    }
    roleListBox.value.push(obj)
    // upRoles(textId.value, roleListBox.value)
}
// 编辑角色
const roleImgBoxShow = ref(false)
const roleEditOne = ref()
const roleEditOneIndex = ref(0)
const openRole = (role: any, index: number) => {
    closeAll()
    roleEditOne.value = role
    roleImgBoxShow.value = true
    roleEditOneIndex.value = index
    
}
// 删除角色
const delRole = (role: any,index: number) => {
    console.log('删除角色')
    console.log(role)
    let haveRole=editData.value.filter(item=> (item.role==role.id) )
    if(haveRole.length>0){
        ElMessage.error("字幕中存在该角色，无法删除!");
        return
    }
    newCaptionApi.getTtsRoles(textId.value).then(res=>{
        console.log(res)
        let listRole=res.data.roles.filter(item=>item.id==role.id)[0]
        if(listRole==undefined){
             roleListBox.value.splice(index, 1)
             ElMessage.success("角色删除成功!");
        }else{
            newCaptionApi.delTtsRoles(textId.value, role.id).then(res => {
                console.log(res.code)
                if (res.code == 200) {
                    roleListBox.value.splice(index, 1)
                    upRoles(textId.value, roleListBox.value)
                    ElMessage.success("角色删除成功!");
                }
            })
        }
            
       
    })
    
    
}
// 字幕展示角色列表
const showImgListIndex = ref(-1)
const showImgList = (index: number) => {
    console.log('字幕展示角色列表')
    showImgListIndex.value = index
}

const closeroleImgList = () => {
    showImgListIndex.value = -1
}
// 修改编辑角色信息
const editRoleImg = (data: string) => {
    roleListBox.value[roleEditOneIndex.value] = JSON.parse(data)
    upRoles(textId.value, roleListBox.value)
}
// 上传编辑信息
const upRoles = (textId: string, roles: any) => {

    newCaptionApi.putInitOneroles(textId, roles).then(res => {
        // console.log(res.code)
        if (res.code == 200) {
            // roleImgBoxShow.value = false
            ElMessage.success("角色信息更新成功!");

            // handleClose()


        }
    })

}
// 翻译
const newTranslate = (data: any) => {
    console.log(data)
    translateBoxShow.value = false
    onOffrevoke.value= false
    showlodaing.value=true
    dataOrChange.value=[]
    let style=''
    data[2] !='自定义' ? style=data[2] :style=data[3]
    console.log(style)
    // newCaptionApi.addTextEn(textId.value, data[0], data[1]).then(res => {
    newCaptionApi.addTextEnAi(textId.value, data[0], data[1],style).then(res => {
        console.log(res.code)
        newCaptionApi.getEditCaption(subtitleId.value,textId.value).then((res) => {
           
            console.log('=========')
            editData.value = JSON.parse(JSON.stringify(res.data[0].subtitles))
            if(editData.value[0].original.text==undefined){
                editData.value[0].original.text=''
            }
            const user = JSON.parse(localStorage.getItem('user'))
            user.user.id==res.data[0].userId?isMy.value=true:isMy.value=false
            captionTextOld.value = JSON.parse(JSON.stringify(res.data[0].subtitles))
            // 判断是否有翻译
            translatShow.value = (res.data[0].subtitles.filter(item =>(item.translation!=undefined&&item.translation.text != undefined&&item.translation.text!='')).length>0) ? true : false
            deltranslatShow.value = (res.data[0].subtitles.filter(item =>(item.translation!=undefined&&item.translation.text != undefined&&item.translation.text!='')).length>0) ? true : false
            console.log(deltranslatShow.value)
            ttstore.updataTranslatState(deltranslatShow.value)
            // 
            enText.value=captionTextOld.value[styleInde.value].translation.text
            language.value = res.data[0].language
            translationLanguage.value= res.data[0].translationLanguage
            subtitleLogsAll.value = res.data[0].subtitleLogs||[]
            nextTick(() => {
                waveChild.value.addtranslat(res.data[0].subtitles)
                showlodaing.value=false
            })  
            editData.value.forEach(item => {
                item.isPlay=false
            });
            
           
        })

    }).catch(err=>{
        showlodaing.value=false 
    })
}
// 简繁转换
const simplifiedTo = () => {
    simplifiedShow.value = false
    showlodaing.value=true
    newCaptionApi.textConvert(textId.value).then(res => {
        console.log(res.code)
        if(res.code==200){
            newCaptionApi.getEditCaption(subtitleId.value,textId.value).then((res) => {
                editData.value = res.data[0].subtitles
                if(editData.value[0].original.text==undefined){
                    editData.value[0].original.text=''
                }
                const user = JSON.parse(localStorage.getItem('user'))
                user.user.id==res.data[0].userId?isMy.value=true:isMy.value=false
                captionTextOld.value = JSON.parse(JSON.stringify(res.data[0].subtitles))
                // 判断是否有翻译
                translatShow.value = (editData.value.filter(item =>(item.translation!=undefined&&item.translation.text != undefined&&item.translation.text!='')).length>0) ? true : false
                deltranslatShow.value = (editData.value.filter(item =>(item.translation!=undefined&&item.translation.text != undefined&&item.translation.text!='')).length>0) ? true : false
                console.log(deltranslatShow.value)
                ttstore.updataTranslatState(deltranslatShow.value)
                // 
                language.value = res.data[0].language
                subtitleLogsAll.value = res.data[0].subtitleLogs||[]
                waveChild.value.textChange(res.data[0].subtitles)
                showlodaing.value=false
                editData.value.forEach(item => {
                    item.isPlay=false
                });
                if(isTtsOpen.value){
                    originalData.value.forEach((item)=>{
                        editData.value.filter((it)=>it.id==item.id)[0].ttsOriginalData=item
                    })
                    
                }else{
                    dubbingData.value.forEach((item)=>{
                        editData.value.filter((it)=>it.id==item.id)[0].ttsDubbingData=item
                    })  
                }
            })
        }else{
            showlodaing.value=false    
        }
       
    }).catch(err=>{
        showlodaing.value=false 
    })
}

// 提交编辑信息
/*
   -- type---
    modifyTime * 调整时间
    modifyRole * 调整角色
    modifyOriginalText * 修改原文
    modifyTranslationText * 修改译文
    modifyOriginalColor * 修改原文颜色
    modifyTranslationColor * 修改译文颜色
    add * 添加
    delete * 删除
    restore * 恢复
    originalTextReplace * 原文替换 
    translationTextReplace * 译文替换 
    addoriginalcomment * 添加原文评论 
    addTranslationComment * 添加译文评论 
    delete0riginalComment * 删除原文评论 
    deleteTranslationcomment * 删除译文评论 

*/
// const saveTextrevoke=(data:object,id:string,line:number,type:string)=>{
//     console.log('提交编辑信息')

//     newCaptionApi.putEditCaption(textId.value,data,id,line,type).then(res => {
//         console.log(res.code)
//     })
// }
// 字幕编辑
const waveChild = ref()
const editTextIndex = ref(-1)
const editTextIndexType = ref('')//字幕类型
const editText = (index: number, type: string, data: any) => {
    closeAll()
    editTextIndex.value = index
    editTextIndexType.value = type
    busydata.value = data
    busyRefIndex.value = index
    indexOfChange.value = index
    oldIndexData.value = captionTextOld.value[index]
    changeType.value = type
    onoffEnter.value=false


}
const updataText = (type: string, index: number, text: string) => {
    console.log(type)

    if (type == 'cn') {
        busydata.value.original.text = text
    } else {
        busydata.value.translation.text = text
    }
    waveChild.value.updataText(type, index, text)
    if (onOffrevoke.value) {
        dataOrChange.value = dataOrChange.value.slice(0, (revokeindex.value + 1))
        onOffrevoke.value = false
        revokeindex.value = -1
    }
}
// 右键编辑
const busyRefShow = ref(false)//编辑模块
// 右键信息
const busydata = ref()
const busyRef = ref()
const busyRefIndex = ref()
const busyThisId = ref()
const initLog = ref([])//初始话单条记录
const preventDefault = (e: any, data: object, index: number) => {
    // console.log(e)
    // console.log(subtitleLogsAll.value)
    busyThisId.value = data.id
    subtitleLogsOne.value=subtitleLogsAll.value.filter(item=>item.id==data.id) || []
    if(initData.value.initSubtitles.filter(item=>item.id==data.id).length!=0){
        initLog.value=initData.value.initSubtitles.filter(item=>item.id==data.id)
        initLog.value[0].createTime= initData.value.createTime 
    }
    
    
    if (initLog.value.length > 0) {
        initLog.value[0].subtitleType = initData.value.subtitleType
       
    }
    
    
    busyRefShow.value = true
    busydata.value = data
    busyRefIndex.value = index
    indexOfChange.value = index
    adduuid.value = JSON.parse(JSON.stringify(uuid().replaceAll("-", "")))
    nextTick(() => {
        busyRef.value.style.top = (e.pageY + 'px')
        busyRef.value.style.left = (e.clientX + 'px')
    })

}
// 编辑删除
const busyDelFun = () => {
    opendelShow.value=true
}
const recognition=()=>{
    opendelShow.value=false
    indexOfChange.value = busyRefIndex.value
    oldIndexData.value = captionTextOld.value[busyRefIndex.value]
    changeType.value = 'delText'
    newIndexData.value = JSON.parse(JSON.stringify(editData.value[indexOfChange.value]))
    const objs = {
        index: indexOfChange.value,
        old: oldIndexData.value,
        new: newIndexData.value,
        type: changeType.value
    }
   
    if (onOffrevoke.value) {
        dataOrChange.value = dataOrChange.value.slice(0, (revokeindex.value + 1))
        onOffrevoke.value = false
        revokeindex.value = -1
    }
    dataOrChange.value.push(objs)
    newCaptionApi.putEditCaption(textId.value, {}, busydata.value.id, busyRefIndex.value, 'delete',ttsStatus.value).then(res => {

        if (res.code == 200) {
            // editData.value.splice(busyRefIndex.value, 1)
            waveChild.value.delText(busyRefIndex.value)
            busyRefShow.value = false
            // if (onOffrevoke.value) {
            //     dataOrChange.value = dataOrChange.value.slice(0, (revokeindex.value + 1))
            //     onOffrevoke.value = false
            //     revokeindex.value = -1
            // }


        }

    })
}
// 编辑向下拆分
const adduuid = ref('')
const busyAdd = () => {
    const thisData = JSON.parse(JSON.stringify(busydata.value))
    console.log('编辑向下拆分========')
    console.log(thisData)
    const time = (thisData.beginTime * 1 + (thisData.endTime - thisData.beginTime) / 2).toFixed(0)
    const obj = {
        beginTime: time,
        endTime: thisData.endTime,
        original: {
            text: ''
        },
        // translation: {
        //     text: ''
        // },
        id: JSON.parse(JSON.stringify(adduuid.value))
    }
    if(thisData.role!=undefined){
        obj.role=thisData.role
    }
    if(deltranslatShow.value){
        obj.translation= {
            text: ''
        }
    }
    console.log(obj)
    editData.value.splice((busyRefIndex.value + 1), 0, obj)
    const ids=JSON.parse(JSON.stringify(adduuid.value))
    nextTick(()=>{
        const datatime = {
            beginTime: thisData.beginTime,
            endTime: time,
        }
        editData.value[busyRefIndex.value].endTime = time
        const addTime = {
            beginTime: time,
            endTime: thisData.endTime,
            original: {
                text: thisData.original.text
            },
            // translation: {
            //     text: ''
            // },
            id: ids
        }
        editFunction(datatime, 'modifyTime')
       
        busydata.value.id=ids
        newCaptionApi.putEditCaption(textId.value, addTime, ids, busyRefIndex.value + 1, 'add',ttsStatus.value).then(res => {
            if (res.code == 200) {
                console.log('编辑成功------------')
                // editFunction(addTime, 'add')
                editFunction(addTime.original, 'modifyOriginalText')

                if(deltranslatShow.value){
                    addTime.translation= {
                        text: thisData.translation.text
                    }
                    editFunction(addTime.translation, 'modifyTranslationText')
                }
                if(thisData.role!=undefined){
                    addTime.role=thisData.role
                    editFunction({ role: addTime.role}, 'modifyRole')
                }
                waveChild.value.addText(busyRefIndex.value)
                busyRefShow.value = false

                indexOfChange.value = busyRefIndex.value
                oldIndexData.value = captionTextOld.value[busyRefIndex.value]
                changeType.value = 'splitText'
                pushNewData()
                // if (onOffrevoke.value) {
                //     dataOrChange.value = dataOrChange.value.slice(0, (revokeindex.value + 1))
                //     onOffrevoke.value = false
                //     revokeindex.value = -1
                // }
            }
        })
       
    })
    
}
// 编辑向下合并
const mergeText = () => {
    console.log('向下合并')
    console.log(editData.value)
    if (onOffrevoke.value) {
        dataOrChange.value = dataOrChange.value.slice(0, (revokeindex.value + 1))
        onOffrevoke.value = false
        revokeindex.value = -1
    }
    indexOfChange.value = busyRefIndex.value
    oldIndexData.value = [editData.value[busyRefIndex.value], editData.value[busyRefIndex.value + 1]]
    changeType.value = 'mergeText'
    let selIndex = busyRefIndex.value
    console.log(editData.value[selIndex + 1].id)
    let  obj = {
        beginTime: editData.value[selIndex].beginTime,
        endTime: editData.value[selIndex + 1].endTime,
        original: {
            text: editData.value[selIndex].original.text + editData.value[selIndex + 1].original.text,
            textColor: editData.value[selIndex].original.textColor
        },
        

        // role: editData.value[selIndex + 1].role,
        id: editData.value[selIndex].id,
    }
    if(editData.value[selIndex + 1].role!=undefined){
        obj.role=editData.value[selIndex + 1].role
    }
    if(deltranslatShow.value){
        obj.translation= {
            text: editData.value[selIndex].translation.text + editData.value[selIndex + 1].translation.text,
            textColor: editData.value[selIndex].translation.textColor
        }
    }
    const objTime = {
        beginTime: editData.value[selIndex].beginTime,
        endTime: editData.value[selIndex + 1].endTime,
    }
    editData.value.splice((selIndex), 1, obj)
    // 原文编辑
    newCaptionApi.putEditCaption(textId.value, { text: obj.original.text }, obj.id, selIndex + 1, 'modifyOriginalText',ttsStatus.value).then(res => {
        if (res.code == 200) {
            console.log('编辑成功')
        }
    })
    if(deltranslatShow.value){
         // 译文编辑
        newCaptionApi.putEditCaption(textId.value, { text: obj.translation.text }, obj.id, selIndex + 1, 'modifyTranslationText',ttsStatus.value).then(res => {
            if (res.code == 200) {
                console.log('编辑成功')
            }
        })
    }
   
    // 时间编辑
    newCaptionApi.putEditCaption(textId.value, objTime, obj.id, selIndex + 1, 'modifyTime',0).then(res => {
        if (res.code == 200) {
            console.log('编辑成功')
        }
    })
    waveChild.value.mergeText(selIndex)

    // 删除
    newCaptionApi.putEditCaption(textId.value, {}, editData.value[selIndex + 1].id, selIndex + 2, 'delete',ttsStatus.value).then(res => {

        if (res.code == 200) {
            editData.value.splice(selIndex + 1, 1)
            waveChild.value.delText(selIndex + 1)
            busyRefShow.value = false
        }

    })
    pushNewData()
    // waveChild.value.delText(selIndex + 1)

}
// 编辑封装
const editFunction = (data: any, type: string) => {
    // console.log(data)
    // console.log(editData.value[busyRefIndex.value].ttsAudio)
    if (type == 'add') {
        newCaptionApi.putEditCaption(textId.value, data, adduuid.value, busyRefIndex.value + 1, type,ttsStatus.value).then(res => {
            if (res.code == 200) {
                console.log('编辑成功')
            }
        })
    } else {
        let ttsStatusStyle=''
        if(type=='modifyTime'||type=='modifyOriginalColor'||type=='modifyTranslationColor'||(editData.value[busyRefIndex.value].ttsAudio!=undefined &&editData.value[busyRefIndex.value].ttsAudio.status ==-1 )){
            ttsStatusStyle=0
        }else{
            ttsStatusStyle=ttsStatus.value
        }
        newCaptionApi.putEditCaption(textId.value, data, busydata.value.id, busyRefIndex.value + 1, type,ttsStatusStyle).then(res => {
            if (res.code == 200) {
                console.log('编辑成功')
                if((type=='modifyOriginalText'||type=='modifyTranslationText')&&isTtsOpen.value){
                   getReData()

                }
            }
        })
    }

}
const pushNewData = () => {
    if (onOffrevoke.value) {
        dataOrChange.value = dataOrChange.value.slice(0, (revokeindex.value + 1))
        onOffrevoke.value = false
        revokeindex.value = -1
    }
    newIndexData.value = JSON.parse(JSON.stringify(editData.value[indexOfChange.value]))
    if (changeType.value == 'splitText') {
        newIndexData.value.id = JSON.parse(JSON.stringify(adduuid.value))
    }
    const objs = {
        index: indexOfChange.value,
        old: oldIndexData.value,
        new: newIndexData.value,
        type: changeType.value
    }
    console.log('撤销数据==============')
    dataOrChange.value.push(objs)
    console.log(dataOrChange.value)
    // revokeindex.value += 1
}
// 撤销恢复编辑
const editFunctionReplay = (data: any, id: string, index: number, type: string) => {
    newCaptionApi.putEditCaption(textId.value, data, id, index, type,ttsStatus.value).then(res => {
        if (res.code == 200) {
            console.log('编辑成功')
            showMessageIndex.value = -1
        }
    })

}
// 替换角色
const selectOne = (item: any, index: number, thisid: string) => {
    console.log('替换角色')
    console.log(item)
    busydata.value = item
    busyRefIndex.value = index
    // const data=item
    const data = {
        role: thisid
    }
    console.log(data)
    // data.role=thisid
    editData.value[index].role = thisid

    // saveTextrevoke(data,item.id,index,'modifyRole')
    editFunction(data, 'modifyRole')
    closeroleImgList()
}
// 原文回车编辑
const onoffEnter=ref(false)
const handleEnter=(event:any,str:string,index:number,data:object)=>{
    console.log(data)
    console.log(index)
    const objsData = {
        index: index,
        old: JSON.parse(JSON.stringify(data)),
        new: '',
        type: 'splitTextEnter'
    }
    const input = event.target;
    const cursorCharIndex = input.selectionStart;
    const part1 = str.slice(0, cursorCharIndex); 
    const part2 = str.slice(cursorCharIndex); 
    onoffEnter.value=true
    // editTextIndex.value =-1
    busyRefIndex.value= index
    indexOfChange.value = index
    adduuid.value = JSON.parse(JSON.stringify(uuid().replaceAll("-", "")))
    const time = (data.beginTime * 1 + (data.endTime - data.beginTime) / 2).toFixed(0)
    let partTrans1
    let partTrans2
    busydata.value=data
    const ids=JSON.parse(JSON.stringify(adduuid.value))
    if(deltranslatShow.value){
        newCaptionApi.oneTextEn(part1,translationLanguage.value,language.value).then(res=>{
            if(res.code==200){
                partTrans1=res.msg
                 // 编辑当前条原文译文时间
                editFunctionReplay({text:part1},data.id,index,'modifyOriginalText')
                editFunctionReplay({text:partTrans1},data.id,index,'modifyTranslationText')
                const datatime = {
                    beginTime: data.beginTime,
                    endTime: time,
                }
                // editFunction(datatime, 'modifyTime')
                editFunctionReplay(datatime,data.id,index,'modifyTime')
                newCaptionApi.oneTextEn(part2,translationLanguage.value,language.value).then(res=>{
                    if(res.code==200){
                        partTrans2=res.msg
                       
                        // editFunction({text:part1}, 'modifyOriginalText')
                        // editFunction({text:partTrans1}, 'modifyTranslationText')
                        
                        nextTick(()=>{
                            busydata.value.id=ids
                            // busyRefIndex.value+=1
                            // 上一条
                            const oldData={
                                beginTime: data.beginTime,
                                endTime: time,
                                original: {
                                    text:part1
                                },
                                translation: {
                                    text:partTrans1
                                }
                            }
                            // 编辑下一条
                            const addObj = {
                                beginTime: time,
                                endTime: data.endTime,
                                original: {
                                    text:part2
                                },
                                translation: {
                                    text:partTrans2
                                },
                                id: ids
                            }

                            newCaptionApi.putEditCaption(textId.value, addObj, ids, index+1, 'add',ttsStatus.value).then(res => {
                                console.log(res)
                                editFunctionReplay(addObj.original,ids,index+ 1,'modifyOriginalText')
                                editFunctionReplay(addObj.translation,ids,index+ 1,'modifyTranslationText')
                                // editFunction(addObj.original, 'modifyOriginalText')
                                // editFunction(addObj.translation, 'modifyTranslationText')
                                if(data.role!=undefined){
                                    addObj.role=data.role
                                    // editFunction({ role: addObj.role}, 'modifyRole')
                                    editFunctionReplay({ role: addObj.role},ids,index+ 1,'modifyRole')
                                }
                                editTextIndex.value=-1
                                objsData.new=[oldData,addObj]
                                dataOrChange.value.push(objsData)
                            })
                        })
                        


                    }
                })
            }
        })
    }else{
        // 编辑当前条原文译文时间
        // editFunction({text:part1}, 'modifyOriginalText')
        editFunctionReplay({text:part1},data.id,index,'modifyOriginalText')            
        const datatime = {
            beginTime: data.beginTime,
            endTime: time,
        }
        // editFunction(datatime, 'modifyTime')
        editFunctionReplay(datatime,data.id,index,'modifyTime')
        nextTick(()=>{
            busydata.value.id=ids
            // busyRefIndex.value+=1
             // 上一条
             const oldData={
                beginTime: data.beginTime,
                endTime: time,
                original: {
                    text:part1
                },
            }
             // 编辑下一条
            const addObj = {
                beginTime: time,
                endTime: data.endTime,
                original: {
                    text:part2
                },
            
                id: ids
            }

            newCaptionApi.putEditCaption(textId.value, addObj, ids, index+1 , 'add',ttsStatus.value).then(res => {
                console.log(res)
                // editFunction(addObj.original, 'modifyOriginalText')
                editFunctionReplay(addObj.original,ids,index+ 1,'modifyOriginalText')
                if(data.role!=undefined){
                    addObj.role=data.role
                    // editFunction({ role: addObj.role}, 'modifyRole')
                    editFunctionReplay({ role: addObj.role},ids,index+ 1,'modifyRole')
                }
                editTextIndex.value=-1
                objsData.new=[oldData,addObj]
                dataOrChange.value.push(objsData)
            })
        })
       
    }
  
}
// 删除键
const handleDelete=(event:any,str:string,index:number,data:object)=>{
    console.log(data)
    console.log(index)
//     if(index==0){
//         return
//     }
//     const input = event.target;
//     const cursorCharIndex = input.selectionStart;
//    if(cursorCharIndex==0){
//         busyThisId.value = editData.value[index-1].id
//         busydata.value =editData.value[index-1]
//         busyRefIndex.value = (index-1)
//         indexOfChange.value = (index-1)
//         mergeText()
//    }


}
// 原文编辑
const originalEdit = () => {
    // console.log('原文编辑')
    // console.log(busydata.value.original)
    if(onoffEnter.value){
        return
    }
    const data = {
        text: busydata.value.original.text
    }
    editFunction(data, 'modifyOriginalText')
    pushNewData()
}

// 原文颜色编辑
const originaColorlEdit = () => {
    console.log('原文编辑')
    const data = {
        textColor: busydata.value.original.textColor
    }
    // newCaptionApi.putEditCaption(textId.value,data,busydata.value.id,busyRefIndex.value,'modifyOriginalColor').then(res => { 
    //     if(res.code==200){
    //         console.log('编辑成功')
    //     } 
    // })
    editFunction(data, 'modifyOriginalColor')
    pushNewData()
}

// 译文编辑
const translationEdit = () => {
    console.log('原文编辑')
    console.log(busydata.value.translation)
    const data = {
        text: busydata.value.translation.text
    }
    editFunction(data, 'modifyTranslationText')
    pushNewData()
    // newCaptionApi.putEditCaption(textId.value,data,busydata.value.id,busyRefIndex.value,'modifyTranslationText').then(res => { 
    //     if(res.code==200){
    //         console.log('编辑成功')
    //     } 
    // })
}
const focusColorfun=(index: number, type: string, data: any)=>{
    focusColor.value=true
    closeAll()
    editTextIndex.value = index
    editTextIndexType.value = type
    busydata.value = data
    busyRefIndex.value = index
    indexOfChange.value = index
    oldIndexData.value = captionTextOld.value[index]
    changeType.value = type
}
// 译文颜色编辑
const translationColorlEdit = () => {
    console.log('原文编辑')
    const data = {
        textColor: busydata.value.translation.textColor
    }
    editFunction(data, 'modifyTranslationColor')
    pushNewData()
    // newCaptionApi.putEditCaption(textId.value,data,busydata.value.id,busyRefIndex.value,'modifyTranslationColor').then(res => { 
    //     if(res.code==200){
    //         console.log('编辑成功')
    //     } 
    // })
}
//时间区间编辑 
const timelEdit = () => {
    console.log('原文编辑')
    const data = {
        beginTime: editData.value[busyRefIndex.value].beginTime,
        endTime: editData.value[busyRefIndex.value].endTime,
    }
    console.log('时间区间编辑 ')
    console.log(dataOrChange.value)
    
    editFunction(data, 'modifyTime')
    pushNewData()
    // newCaptionApi.putEditCaption(textId.value,data,busydata.value.id,busyRefIndex.value,'modifyTime').then(res => { 
    //     if(res.code==200){
    //         console.log('编辑成功')
    //     } 
    // })
}
// 打开历史编辑
const subtitleLogsOne = ref()

const busyHistory = () => {
    console.log('打开历史编辑')
    busyRefShow.value = false
    if(subtitleLogsOne.value.length>0){
        historyEditShow.value = true
    }else{
        ElMessage({
            message: '暂无历史记录',
            type: 'success',
        })
        return
    }
   
}
// 修改字体颜色
const focusColor=ref(false)
const changeColor = (index: number, type: string, event: string, item: object) => {
    console.log(index)
    console.log(event)
    busydata.value = item
    busyRefIndex.value = index
    if (type == 'cn') {
        editData.value[index].original.textColor = event
        busydata.value.original.textColor = event
        originaColorlEdit()
        focusColor.value=false
    } else {
        editData.value[index].translation.textColor = event
        busydata.value.translation.textColor = event
        translationColorlEdit()
        focusColor.value=false
    }

}
// 默认规则参数
const checkRule = ref({
    maximumDuration: '10',
    minimumDuration: '1',
    originalMaximumWordCount: '18',
    translationOriginalMaximumWordCount: '75'
})
// 修改规则
const changeRuleFun = (data: any) => {
    console.log(data)
    ruleShow.value = false
    checkRule.value = JSON.parse(data)
    newCaptionApi.putInitOneRule(subtitleId.value, checkRule.value).then(res => {
        console.log(res.code)
    })
}
// 是否开启检查字幕
const openRuleFun = (data: boolean) => {
    console.log(data)
    textinspectShow.value = data

}
// 是否过滤不符合规则字幕
const filterRuleList=ref([])
const textfilterShow = ref(false)
const openFilterTxtFun = (data: boolean) => {
    console.log(data)
    textfilterShow.value = data
    filterRuleList.value=[]
    filterRuleList.value=editData.value.filter(item=>(((item.endTime - item.beginTime) / 1000)) > checkRule.value.maximumDuration || (((item.endTime - item.beginTime) / 1000)) < checkRule.value.minimumDuration
        ||(item.translation!=undefined && item.translation.text.length) > checkRule.value.translationOriginalMaximumWordCount
        ||(item.original.text.length) > checkRule.value.originalMaximumWordCount
    )
    console.log(filterRuleList.value)
    // textfilterShow.value = data
}
//播放过滤不符合规则字幕音频
const playFilterTxtFun = () => {
    console.log('播放过滤不符合规则字幕音频')
    
}
// 跳转到指定片段
const jumpToSegment = (segment:any) => {
  if (videoRef.value) {
    videoRef.value.currentTime = segment.startTime/1000
  }else{
    audioRef.value.currentTime = segment.startTime/1000
  }
}
// 初始化Peak数据
const waveCanvasShow = ref(false)
const editId = ref('')
const demoData = reactive({
    duration: 30,//时长秒
    runRate: 62,//每秒音频播放速率
    peaks: [],//波峰数据
    id: '',
    canvasWidth: 0,
    subtitleId:''
})
const waveBoxIidth = ref(0)//音轨容器宽度
const waveWidthRef = ref()
const startTime = ref(0)//视频进行时间
const leaveTime = ref(0)//视频剩余时间
const totalTime = ref(0)//视频总时间
const timesLider = ref(0)//进度条初始时间
const updateTimeShow = ref(0)
const playShow = ref(false)//是否播放
const initPeaks = (editId) => {
    newCaptionApi.getwave(editId, 256, 1, Math.ceil((waveBoxIidth.value / 62.5) * 16000)).then(res => {
        // console.log(res.data)
        demoData.peaks = res.data
        // console.log(demoData)
        waveCanvasShow.value = true
    })
}
// 修改时间
const textUpdateTime = (left: number, width: number, index: number, speedSpeak: number) => {
    const beginTime = Math.ceil(left / speedSpeak * 1000)
    const endTime = Math.ceil((left + width) / speedSpeak * 1000)
    editData.value[index].beginTime = beginTime
    editData.value[index].endTime = endTime
    // console.log(editData.value[index])

    busyRefIndex.value = index

}
// 撤销文字编辑
const revokeText = (type: string, data: any, runType: string) => {
    console.log('撤销文字编辑')
    console.log(type)
    if (runType == 'revoke') {
        if (type == 'cn') {
            editData.value[data.index].original.text = data.old.original.text
            editFunctionReplay({ text: data.old.original.text }, editData.value[data.index].id, data.index, 'modifyOriginalText')
            // saveTextrevoke()
        } else {
            editData.value[data.index].translation.text = data.old.translation.text
            editFunctionReplay({ text: data.old.translation.text }, editData.value[data.index].id, data.index, 'modifyTranslationText')
            // saveTextrevoke()
        }
        if (revokeindex.value > -1) {
            revokeindex.value -= 1
        }

    } else {

        // console.log( dataOrChange.value)
        if (type == 'cn') {
            editData.value[data.index].original.text = data.new.original.text
            editFunctionReplay({ text: data.new.original.text }, editData.value[data.index].id, data.index, 'modifyOriginalText')

            // saveTextrevoke()
        } else {
            editData.value[data.index].translation.text = data.new.translation.text
            editFunctionReplay({ text: data.new.translation.text }, editData.value[data.index].id, data.index, 'modifyTranslationText')
            // saveTextrevoke()
        }

    }


}
// 撤销原文颜色
const revokeCncolor=( data: any,runType: string)=>{
    console.log(data)
    if (runType == 'revoke') {
        const datas = {
            textColor: data.old.original.textColor
        }
        editData.value[data.index].original.textColor = data.old.original.textColor
        editFunction(datas, 'modifyOriginalColor')
        if (revokeindex.value > -1) {
            revokeindex.value -= 1
        }
    }else{
        const datas = {
            textColor: data.new.original.textColor
        }
        editData.value[data.index].original.textColor = data.new.original.textColor
        editFunction(datas, 'modifyOriginalColor')
    }
}
// 撤销译文颜色
const revokeEncolor=( data: any,runType: string)=>{
    console.log(data)
    if (runType == 'revoke') {
        const datas = {
            textColor: data.old.translation.textColor
        }
        editData.value[data.index].translation.textColor = data.old.translation.textColor
        editFunction(datas, 'modifyTranslationColor')
        if (revokeindex.value > -1) {
            revokeindex.value -= 1
        }
    }else{
        const datas = {
            textColor: data.new.translation.textColor
        }
        editData.value[data.index].translation.textColor = data.new.translation.textColor
        editFunction(datas, 'modifyTranslationColor')
    }
}
// 撤销单个文字替换
const revokeReplaceOne=( data: any,runType: string)=>{
    console.log(data)
    console.log(runType)
    if (runType == 'revoke') {
        if (data.type == 'toReplaceoriginal') {
            editData.value[data.index].original.text = data.old.original.text
            editFunctionReplay({ text: data.old.original.text }, editData.value[data.index].id, data.index, 'modifyOriginalText')
            
        } else {
            editData.value[data.index].translation.text = data.old.translation.text
            editFunctionReplay({ text: data.old.translation.text }, editData.value[data.index].id, data.index, 'modifyTranslationText')
            
        }
        if (revokeindex.value > -1) {
            revokeindex.value -= 1
        }
    }else{
        if (data.type == 'toReplaceoriginal') {
            editData.value[data.index].original.text = data.new.original.text
            editFunctionReplay({ text: data.new.original.text }, editData.value[data.index].id, data.index, 'modifyOriginalText')
        } else {
            editData.value[data.index].translation.text = data.new.translation.text
            editFunctionReplay({ text: data.new.translation.text }, editData.value[data.index].id, data.index, 'modifyTranslationText')
    
        }
    }
}
// 撤销批量替换
const revokeReplaceList=( data: any,runType: string)=>{
    console.log(data)
    console.log(runType)
    if (runType == 'revoke') {
        newCaptionApi.putEditbatchCaption(textId.value, data.old).then(res=>{
            console.log(res)
           
        })
        if (revokeindex.value > -1) {
            revokeindex.value -= 1
        }
    }else{
        newCaptionApi.putEditbatchCaption(textId.value, data.new).then(res=>{
            console.log(res)
           
        })
    }
}
// 撤销删除
const revokeDel = (data: any, runType: string) => {


    console.log(runType)
    console.log(data)
    if (runType == 'revoke') {
        editData.value.splice((data.index), 0, data.old)
        editFunctionReplay(data.old, data.old.id, data.index, 'restore')
        // 恢复字幕
        waveChild.value.revokeaddText(data)
        if (revokeindex.value > -1) {
            revokeindex.value -= 1
        }
    } else {
        editFunctionReplay({}, data.old.id, data.index, 'delete')
        editData.value.splice(data.index, 1)
        waveChild.value.delText(data.index)
    }
}
// 撤销拆分
const revokeAddText = (data: any, runType: string) => {
    console.log('撤销恢复字幕拆分')
    // console.log(runType)
    // console.log(data)
    if (runType == 'revoke') {
        // waveChild.value.splitTextRevoke(data.old)
        const obj = {
            beginTime: data.old.beginTime,
            endTime: data.old.endTime,
            original: {
                text: data.old.original.text,
            },
            // translation: {
            //     text: data.old.translation.text,
            // },
            role: data.old.role,
            id: data.old.id,
        }
        // if(deltranslatShow.value){
        //     obj.translation={
        //         text :data.old.translation.text
        //     }
        //     editFunctionReplay(obj.translation, data.old.id, data.index, 'modifyTranslationText')
        // }
        editFunctionReplay({ beginTime: data.old.beginTime, endTime: data.old.endTime, }, data.old.id, data.index, 'modifyTime')
        editFunctionReplay({}, data.new.id, data.index + 1, 'delete')
        // editFunctionReplay(obj.original, data.old.id, data.index, 'modifyOriginalText')
               
        editData.value.splice((data.index), 1, obj)
        editData.value.splice((data.index + 1), 1)
        waveChild.value.mergeText(data.index)
        // saveTextrevoke()
        if (revokeindex.value > -1) {
            revokeindex.value -= 1
        }
    } else {

        const obj = {
            beginTime: data.old.beginTime * 1 + (data.old.endTime - data.old.beginTime) / 2,
            endTime: data.old.endTime,
            original: {
                text: data.new.original.text,
            },
            // translation: {
            //     text: '',
            // },
            role: data.old.role,
            id: data.new.id,
        }
        const addTime={
            beginTime: data.old.beginTime * 1 + (data.old.endTime - data.old.beginTime) / 2,
            endTime: data.old.endTime,
        }
        
        editFunctionReplay({ beginTime: data.old.beginTime, endTime: (data.old.beginTime * 1 + (data.old.endTime - data.old.beginTime) / 2), }, data.old.id, data.index, 'modifyTime')

        newCaptionApi.putEditCaption(textId.value, addTime, data.new.id, data.index + 1, 'add', ttsStatus.value).then(res => {
            if(res.code == 200){
                editFunctionReplay(obj.original, data.new.id, data.index + 1, 'modifyOriginalText')
                if(deltranslatShow.value){
                    obj.translation={
                        text : data.new.translation.text
                    }
                    editFunctionReplay(obj.translation, data.new.id, data.index + 1, 'modifyTranslationText')
                }
                editData.value[data.index].endTime = (data.old.beginTime * 1 + (data.old.endTime - data.old.beginTime) / 2)
                editData.value.splice((data.index + 1), 0, obj)
            }
        })
        
        // editFunctionReplay(obj, data.new.id, data.index + 1, 'add')
        // editFunctionReplay(obj.original, data.new.id, data.index + 1, 'modifyOriginalText')
        // editData.value[data.index].endTime = (data.old.beginTime * 1 + (data.old.endTime - data.old.beginTime) / 2)
        // editData.value.splice((data.index + 1), 0, obj)
        waveChild.value.addText(data.index)

    }
}
// 撤销回车
const revokeEnterList = (data: any, runType: string) => {
    
    if (runType == 'revoke') {
        
        const obj = {
            beginTime: data.old.beginTime,
            endTime: data.old.endTime,
            original: {
                text: data.old.original.text,
            },
            id: data.old.id,
        }
        if(deltranslatShow.value){
            obj.translation={
                text :data.old.translation.text
            }
            editFunctionReplay(obj.translation, data.old.id, data.index, 'modifyTranslationText')
        }
        editFunctionReplay(obj.original, data.old.id, data.index, 'modifyOriginalText')
        editFunctionReplay({ beginTime: data.old.beginTime, endTime: data.old.endTime, }, data.old.id, data.index, 'modifyTime')
        editFunctionReplay({}, data.new[1].id, data.index + 1, 'delete')
       
               
        // editData.value.splice((data.index), 1, obj)
        // editData.value.splice((data.index + 1), 1)
        // waveChild.value.mergeText(data.index)
        // saveTextrevoke()
        if (revokeindex.value > -1) {
            revokeindex.value -= 1
        }
    } else {

        const obj = {
            beginTime: data.old.beginTime * 1 + (data.old.endTime - data.old.beginTime) / 2,
            endTime: data.old.endTime,
            original: {
                text: data.new[1].original.text,
            },
            // translation: {
            //     text: '',
            // },
            role: data.old.role,
            id: data.new[1].id,
        }
        const addTime={
            beginTime: data.old.beginTime * 1 + (data.old.endTime - data.old.beginTime) / 2,
            endTime: data.old.endTime,
        }
        
        editFunctionReplay({ beginTime: data.old.beginTime, endTime: (data.old.beginTime * 1 + (data.old.endTime - data.old.beginTime) / 2), }, data.old.id, data.index, 'modifyTime')
        editFunctionReplay(data.new[0].original, data.old.id, data.index, 'modifyOriginalText')
        
        newCaptionApi.putEditCaption(textId.value, addTime, data.new[1].id, data.index + 1, 'add',ttsStatus.value).then(res => {
            if(res.code == 200){
                editFunctionReplay(obj.original, data.new[1].id, data.index + 1, 'modifyOriginalText')
                if(deltranslatShow.value){
                    obj.translation={
                        text : data.new[1].translation.text
                    }
                    editFunctionReplay(obj.translation, data.new[1].id, data.index + 1, 'modifyTranslationText')
                    editFunctionReplay(data.new[0].translation, data.old.id, data.index, 'modifyTranslationText')
                }
                // editData.value[data.index].endTime = (data.old.beginTime * 1 + (data.old.endTime - data.old.beginTime) / 2)
                // editData.value.splice((data.index + 1), 0, obj)
            }
        })
        
        // editFunctionReplay(obj, data.new.id, data.index + 1, 'add')
        // editFunctionReplay(obj.original, data.new.id, data.index + 1, 'modifyOriginalText')
        // editData.value[data.index].endTime = (data.old.beginTime * 1 + (data.old.endTime - data.old.beginTime) / 2)
        // editData.value.splice((data.index + 1), 0, obj)
        waveChild.value.addText(data.index)

    }
}
// 撤销恢复字幕向下合并
const revokeMergeText = (data: any, runType: string) => {
    // console.log('撤销恢复字幕向下合并')
    console.log(data)
    let num = data.index
    if (runType == 'revoke') {
        console.log('撤销向下合并')
        editData.value.splice(num, 1)
        waveChild.value.delText(num)
        data.old.forEach((item, i) => {
            const obj = {
                beginTime: item.beginTime,
                endTime: item.endTime,
                original: {
                    text: item.original.text,
                },
                role: item.role,
                id: item.id,
            }
            if(deltranslatShow.value){
                obj.translation.text = item.translation.text
                }
	
            editData.value.splice((num + i), 1, obj)
            waveChild.value.MergeTextRevoke(item, (num + i))
        })


        editFunctionReplay({ beginTime: data.old[0].beginTime, endTime: data.old[0].endTime, }, data.old[0].id, data.index, 'modifyTime')
        editFunctionReplay({ text: data.old[0].original.text }, data.old[0].id, data.index, 'modifyOriginalText')
        if(deltranslatShow.value){
            editFunctionReplay({ text: data.old[0].translation.text, }, data.old[0].id, data.index, 'modifyTranslationText')
        }
       const addTime={
            beginTime: data.old[1].beginTime ,
            endTime: data.old[1].endTime,
        }
        newCaptionApi.putEditCaption(textId.value, addTime, data.old[1].id, data.index + 1, 'add',ttsStatus.value).then(res => {
            if(res.code == 200){
                editFunctionReplay( data.old[1].original, data.old[1].id, data.index + 1, 'modifyOriginalText')
                if(deltranslatShow.value){
                     data.old[1].translation={
                        text : data.old[1].translation.text
                    }
                    editFunctionReplay( data.old[1].translation, data.old[1].id, data.index + 1, 'modifyTranslationText')
                }
                editData.value[data.index].endTime = (data.old.beginTime * 1 + (data.old.endTime - data.old.beginTime) / 2)
                editData.value.splice((data.index + 1), 0,  data.old[1])
            }
        })

        // editFunctionReplay(data.old[1], data.old[1].id, data.index, 'restore')
        // // saveTextrevoke()
        if (revokeindex.value > -1) {
            revokeindex.value -= 1
        }
    } 
    else {
        const obj = {
            beginTime: data.old[0].beginTime,
            endTime: data.old[1].endTime,
            original: {
                text: data.old[0].original.text + data.old[1].original.text,
                // textColor: editData.value[selIndex].original.textColor
            },
            
            role: data.old[0].role,
            id: data.old[0].id,
        }
        if(deltranslatShow.value){
            obj.translation.text =  data.old[0].translation.text + data.old[1].translation.text
            }
	
        editFunctionReplay({ beginTime: data.old[0].beginTime, endTime: obj.endTime, }, data.old[0].id, data.index, 'modifyTime')
        editFunctionReplay({ text: obj.original.text }, data.old[0].id, data.index, 'modifyOriginalText')
        if(deltranslatShow.value){
            editFunctionReplay({ text: obj.translation.text, }, data.old[0].id, data.index, 'modifyTranslationText')
        }
	    editFunctionReplay({}, data.old[1].id, data.index + 1, 'delete')
       
        editData.value.splice((num), 1, obj)
        editData.value.splice((num + 1), 1)
        waveChild.value.mergeText(num)
        // saveTextrevoke()
    }
}
const revokeTextMove=(data:any,runType:string)=>{
    console.log(data)
    if(runType=='revoke'){
        editData.value[data.index]=data.old
        waveChild.value.revokeMoveText(data,runType)
        editFunctionReplay({ beginTime: data.old.beginTime, endTime:data.old.endTime, }, data.old.id, data.index, 'modifyTime')
        if(revokeindex.value>-1){
                revokeindex.value-=1
        }
    }else{
        editData.value[data.index]=data.new
        waveChild.value.revokeMoveText(data,runType)
        editFunctionReplay({ beginTime: data.new.beginTime, endTime:data.new.endTime, }, data.old.id, data.index, 'modifyTime')
    }
}
// 撤销恢复容器拉伸
const revokelineMove=(data:any,runType:string,lineType:string)=>{
    if(runType=='revoke'){
        
        editData.value[data.index]=data.old
        waveChild.value.revokeMoveLine(data,runType,lineType)
        // saveTextrevoke()
        editFunctionReplay({ beginTime: data.old.beginTime, endTime:data.old.endTime, }, data.old.id, data.index, 'modifyTime')
        if(revokeindex.value>-1){
                revokeindex.value-=1
        }
    }else{
        editData.value[data.index]=data.new
        waveChild.value.revokeMoveLine(data,runType,lineType)
        editFunctionReplay({ beginTime: data.new.beginTime, endTime:data.new.endTime, }, data.new.id, data.index, 'modifyTime')
        // saveTextrevoke()
    }
}


// 字幕拖拽
const updateTimeBoxMove = ([type, e, index]: [type: string, e: any, index: number]) => {
    // console.log(type)
    // console.log(e)
    console.log('字幕拖拽界面接受'+index)
    indexOfChange.value = index
    busydata.value = JSON.parse(JSON.stringify(editData.value[index]))

    // saveText()
    timelEdit()
}
// 字幕历史数据缓存
const waveOldData = ([type, index]: [type: string, index: number]) => {
    console.log('字幕历史数据缓存')
    console.log(type)
    if(onOffrevoke.value){
        dataOrChange.value=dataOrChange.value.slice(0, (revokeindex.value+1))
        onOffrevoke.value=false
        revokeindex.value=-1
    }
    indexOfChange.value=index
    oldIndexData.value=JSON.parse(JSON.stringify(editData.value[index]))
    changeType.value=type
    // console.log(oldIndexData.value)
}
// 标线跳转
// const scrollAreaRef=ref()
const scrollAreaRef = ref<InstanceType<typeof ElScrollbar>>()
const styleInde=ref(0)
const styleDetail = {
    background: 'rgba(30,104,201,0.3)',

}
// const lnineToTimeUp = (time: number) => {
//     console.log('标线跳转' + time)
//     // timesLider.value = time * 100000 / totalTime.value
//     startTime.value = time*1000
//     cnText.value = ''
//     enText.value = ''
//     // console.log('标线跳转'+styleInde.value)
//     // editData.value.forEach((item, index) => {
//     //     if (startTime.value >= item.beginTime && startTime.value <= item.endTime) {
//     //         cnText.value = item.original.text
//     //         if(item.translation!=undefined){
//     //             enText.value = item.translation.text || ''
//     //         }
            
//     //         if (clickIndex.value < 0) {
//     //             scrollAreaRef.value.scrollTop = (60 * (index - 3))
//     //         }

//     //     }

//     // })

//     if (!rePlatTextOff.value) {
//         editData.value.forEach((item, index) => {
//             if (startTime.value >= item.beginTime && startTime.value <= item.endTime) {
//                 cnText.value = item.original.text
//                 if(item.translation!=undefined){
//                     enText.value = item.translation.text || ''
//                     }
                
//                 // 字幕滚动条移动
//                 if (clickIndex.value < 0) {
//                     // console.log('字幕滚动条移动'+index)
                    
//                     // scrollAreaRef.value.scrollTop = (60 * (index - 3))
//                     scrollAreaRef.value!.setScrollTop(60 * (index - 3))
//                 }
                
//                 styleInde.value = (index )
//                 selPlayRange.runtime=time*1000
//                 selPlayRange.beginTime=item.beginTime
//                 selPlayRange.endTime=item.endTime
//                 selPlayRange.index=index
//             }else if(index<(editData.value.length-1)&&index>0){
//                 if(startTime.value>item.endTime&& startTime.value<editData.value[index+1].beginTime){
//                     // console.log('=============')
//                     // scrollAreaRef.value.scrollTop = (60 * (index - 3))
//                     scrollAreaRef.value!.setScrollTop(60 * (index - 3))
//                     styleInde.value = (index )
//                     selPlayRange.runtime=editData.value[index].endTime
//                     cnText.value = editData.value[index].original.text
//                     if(editData.value[index].translation!=undefined){
//                         enText.value = editData.value[index].translation.text || ''
//                     }
                    
//                 }
//             }

//         })
        
//     }else{
//         // 重复播放时进度条
//         selPlayRange.runtime=time*1000
//         if(rePlatTextOff.value&&!playShow.value){
//             selPlayRange.runtime=selPlayRange.endTime
//         }

//     }
//     // 视频跳转
  
//     if (isMp4.value) {
//         console.log(time)
//         videoRef.value.currentTime  = time*1
//     } else {
//         audioRef.value.currentTime  = time*1
//     }
// }
const finishPlayTime = (type: string) => {
    // console.log('结束===============')
    playShow.value = false
    startTime.value = 0
    updateTimeShow.value =0
    clearInterval(playSettime.value)
    // scrollAreaRef.value.scrollTop = 0
    scrollAreaRef.value!.setScrollTop(0)
    styleInde.value = 0
    // cnText.value = ''
    // enText.value = ''
    timesLider.value = 0
    if (isMp4.value) {
            if(videoRef.value?.pause()){
                videoRef.value.pause()
                videoRef.value.currentTime  = 0
            }
            
        } else {
            if(audioRef.value?.pause()){
                audioRef.value.pause()
                audioRef.value.currentTime  = 0
            }
            // audioRef.value.pause()
            // audioRef.value.currentTime  = 0
        }

}
// // 视频播放

// const updateCurrentTime = (event: any) => {
//     // console.log('字幕滚动条移动')
//     // console.log(event.target.currentTime)
//     let time=event.target.currentTime* 1000
//     updateTimeShow.value = event.target.currentTime
//     // // console.log(captionText.value[clickIndex.value-1])
//     startTime.value = event.target.currentTime * 1000
//     // const timeNow = event.target.currentTime
//     // timesLider.value = timeNow * 100000 / totalTime.value
    
//     if (!rePlatTextOff.value) {
//         cnText.value = ''
//         enText.value = ''
//         // console.log('字幕滚动条移动-----------')
//         editData.value.forEach((item, index) => {
//             if (time >= item.beginTime && time <= item.endTime) {
//                 cnText.value = item.original.text
//                 if(item.translation!=undefined){
//                     enText.value = item.translation.text || ''
//                     }
                
//                 // 字幕滚动条移动
//                 if (clickIndex.value < 0) {
//                     // console.log('字幕滚动条移动'+index)
                    
//                     // scrollAreaRef.value.scrollTop = (60 * (index - 3))
//                     scrollAreaRef.value!.setScrollTop(60 * (index - 3))
//                 }
                
//                 styleInde.value = (index )
//                 selPlayRange.runtime=event.target.currentTime*1000
//                 selPlayRange.beginTime=item.beginTime
//                 selPlayRange.endTime=item.endTime
//                 selPlayRange.index=index
//             }else if(index<(editData.value.length-1)&&index>=0){
//                 if(time>item.endTime&& time<editData.value[index+1].beginTime){
//                     // console.log('=============')
//                     // scrollAreaRef.value.scrollTop = (60 * (index - 3))
//                     scrollAreaRef.value!.setScrollTop(60 * (index - 3))
//                     styleInde.value =-1
//                     selPlayRange.runtime=editData.value[index].endTime
//                     cnText.value =''
//                      if(editData.value[index].translation!=undefined){
//                         enText.value =  ''
//                     }
//                     // styleInde.value = (index )
//                     // cnText.value = editData.value[index].original.text
//                     // if(editData.value[index].translation!=undefined){
//                     //     enText.value = editData.value[index].translation.text || ''
//                     // }
                    
//                 }
//             }

//         })
        
//     }else{
//         // console.log('字幕滚动条移动=======')
//         // 重复播放时进度条
//         selPlayRange.runtime=event.target.currentTime*1000
//         if(rePlatTextOff.value&&!playShow.value){
//             selPlayRange.runtime=selPlayRange.endTime
//         }
//         styleInde.value =-1
//         editData.value.forEach((item, index) => {
//             if (time >= item.beginTime && time <= item.endTime) {
//                 cnText.value = item.original.text
//                 if(item.translation!=undefined){
//                     enText.value = item.translation.text || ''
//                 }
//                 styleInde.value=index
//             }
//         })

//     }

    


// }

// 重复播放该字幕
const rePlatTextOff = ref(false)
const clickIndex = ref(-1)
const videoRef = ref()

const enterplayPause=()=>{
    console.log(editTextIndexType.value)
    if(editTextIndexType.value!=''||showMessageIndex.value!=-1){
        return
    }
    // playPause()
}

// 下一条
const nextPlay=()=>{
    if(textfilterShow.value){
        ElMessage({
            message: '请关闭显示筛选规则功能后切换播放',
            type: 'warning',
            duration: 2000
        });
        return
    }
    console.log('下一条'+startTime.value)
   
    let findrunIndex=editData.value.findIndex((item)=>startTime.value>=item.beginTime*1&& startTime.value<=item.endTime*1)
    console.log('findIndex'+findrunIndex)
    if(findrunIndex!=-1&&findrunIndex+1<=editData.value.length-1){
        clickIndex.value=findrunIndex+1
        selPlayRange.runtime=0
        rePlatText(editData.value[clickIndex.value],clickIndex.value)
        return 
    }
    // editData.value.forEach((item, index) => {
    //     if (startTime.value >= item.beginTime*1 && startTime.value <= item.endTime*1) {
    //         if(index+1<=editData.value.length-1){
    //             clickIndex.value=index+1
    //             selPlayRange.runtime=0
    //            rePlatText(editData.value[clickIndex.value],clickIndex.value)
    //            return 
    //         }
           
    //     }

    // })
    
}
// 上一条
const afterPlay=()=>{
    if(textfilterShow.value){
        ElMessage({
            message: '请关闭显示筛选规则功能后切换播放',
            type: 'warning',
            duration: 2000
        });
        return
    }
    let findrunIndex=editData.value.findIndex((item)=>startTime.value>=item.beginTime*1&& startTime.value<=item.endTime*1)
    console.log('findIndex'+findrunIndex)
    if(findrunIndex!=-1&&findrunIndex-1>=0){
        clickIndex.value=findrunIndex-1
        selPlayRange.runtime=0
         rePlatText(editData.value[clickIndex.value],clickIndex.value)
         return
    }
    // editData.value.forEach((item, index) => {
    //     if (startTime.value >= item.beginTime && startTime.value <= item.endTime) {
    //         if(index-1>=0){
    //             clickIndex.value=index-1
    //             selPlayRange.runtime=0
    //             return rePlatText(editData.value[clickIndex.value],clickIndex.value)
    //         }
           
    //     }

    // })
    
}
// 重复播放
const rePlayThis=()=>{
    // console.log('-----')
    // if(clickIndex.value==-1){
    //     return
    // }
    // rePlatText(editData.value[clickIndex.value],clickIndex.value)
    editData.value.forEach((item, index) => {
        if (startTime.value >= item.beginTime && startTime.value <= item.endTime) {
                clickIndex.value=index
                selPlayRange.runtime=0
                rePlatText(editData.value[clickIndex.value],clickIndex.value)
        }

    })
}
// 删除译文
const openDeltranslatShow=ref(false)//删除译文弹窗
const deltranslatText=ref('删除译文将同步删除幻音数据，是否确认删除？')
const openConvert = () => {
    // deltranslatText.value='删除译文将同步删除幻音数据，是否确认删除？'
    openDeltranslatShow.value=true
    // translatShow.value=false
    // deltranslatShow.value=false
    // ttstore.updataTranslatState(deltranslatShow.value)
    // onOffrevoke.value=false
    // dataOrChange.value=[]
    // enText.value=""
    // newCaptionApi.delTextEn( textId.value).then(res=>{
    //    console.log(textId.value)
    //    waveChild.value.hidetranslat([translatShow.value])
    // })

}
//确认删除译文
const confirmDelConvert = () => {
    translatShow.value=false
    deltranslatShow.value=false
    ttstore.updataTranslatState(deltranslatShow.value)
    onOffrevoke.value=false
    dataOrChange.value=[]
    enText.value=""
    newCaptionApi.delTextEn( textId.value).then(res=>{
    //    console.log(textId.value)
       openDeltranslatShow.value=false
       waveChild.value.hidetranslat([translatShow.value])
       ttstore.dubbingClose()
       isOpenttsFun()
       closeAll()
    })
}
 
//  接受推送消息
onMounted(() => {
    // init()
    proxy.$ws.onmessageCaption = (message: any) => {
        // getAiVoiceList()
        console.log('接受推送消息====')
        console.log(message)
        if(message.operation=='updateText'&&message.subtitleId==subtitleId.value&&message.textId==textId.value){
            console.log('重新拉取信息')
            // rePullData()
            getReData()
            newCaptionApi.getInitCaption(subtitleId.value).then((res) => {
                console.log(res)
                initData.value = res.data
                // editId.value = res.data.subtitleId
                demoData.subtitleId = res.data.subtitleId
                demoData.duration= res.data.duration
                initTitle.value = res.data.title
                // 获取规则
                if (res.data.checkRule != null || res.data.checkRule != undefined) {
                    checkRule.value = {...checkRule.value, ...res.data.checkRule}
                }
            
                // roleListBox.value = res.data.roles || []
                // 分享人物
                shareUsers.value = res.data.shareUsers
                // 
                const fileType = res.data.fileName.split('.')[1]
                // console.log(fileType)
                isMp4.value = res.data.mp4Path != undefined;
            
                totalTime.value = (res.data.duration *1)
                //aUrl.value = res.data.fileUrl
                aUrl.value = res.data.mp4Path != undefined ?  res.data.mp4Path :  res.data.wavPath
                // 判断是否是自己发布
                // const user = JSON.parse(localStorage.getItem('user'))
                // user.user.id==res.data.userId?isMy.value=true:isMy.value=false
                // console.log(isMy.value)
            })
        }
        // 拉取单条数据
        if((message.subtitleStatus==11||message.subtitleStatus==12)&&isTtsOpen.value){
            ttsOpenApi.getTtsState(textId.value,0).then((res:any)=>{
                isOpenttsTxt.value=res.data.translationStatus
                if(res.data.translationStatus==100){
                    ttstore.loadState(false)
                    if(ttstore.isDubbing){
                        isTtsDubbing.value=true
                    }
                    getReData()
                }else{
                    if(res.data.translationStatus==1){
                        ttstore.loadState(true)
                    }
                    
                }
                    
            })
            
        }
        // 拉取角色TTS数据
        if(message.subtitleStatus==10&&isTtsOpen.value){
            console.log('拉取角色TTS数据')
            newCaptionApi.getTtsRoles(textId.value).then((res) => {
                console.log(res)
                roleListBox.value = res.data.roles || []
	            ttstore.updataRoleList(roleListBox.value)
                getReData()
            })
        }
    }
})
// 拉取角色TTS数据
const getTtsRolesData=()=>{
    console.log('拉取角色TTS数据============')
    newCaptionApi.getTtsRoles(textId.value).then((res) => {
        console.log(res)
        roleListBox.value = res.data.roles || []
        ttstore.updataRoleList(roleListBox.value)
         ttstore.updataVoiceRoles(res.data.voiceRoles||[])
    })
}   
// 重新拉取数据
const rePullData=()=>{
    newCaptionApi.getEditCaption(subtitleId.value,textId.value).then((res) => {
            editData.value = res.data[0].subtitles
            if(editData.value[0].original.text==undefined){
                editData.value[0].original.text=''
            }
            // ttstore.updataTextList(editData.value)
            const user = JSON.parse(localStorage.getItem('user'))
            user.user.id==res.data[0].userId?isMy.value=true:isMy.value=false
            captionTextOld.value = JSON.parse(JSON.stringify(res.data[0].subtitles))
            // 判断是否有翻译
            // translatShow.value = (res.data[0].subtitles.filter(item =>(item.translation!=undefined&&item.translation.text != undefined&&item.translation.text!='')).length>0) ? true : false
            deltranslatShow.value = (res.data[0].subtitles.filter(item =>(item.translation!=undefined&&item.translation.text != undefined&&item.translation.text!='')).length>0) ? true : false
        
            roleListBox.value = res.data[0].roles || []
            language.value = res.data[0].language
            subtitleLogsAll.value = res.data[0].subtitleLogs||[]
            nextTick(() => {
                waveChild.value.reText(textId.value)
            }) 
            editData.value.forEach(item => {
                item.isPlay=false
            });
            if(isTtsOpen.value){
                originalData.value.forEach((item)=>{
                    editData.value.filter((it)=>it.id==item.id)[0].ttsOriginalData=item
                })
                
            }else{
                dubbingData.value.forEach((item)=>{
                    editData.value.filter((it)=>it.id==item.id)[0].ttsDubbingData=item
                })  
            }
        })
}
// 重新获取数据
const getReData=()=>{
    
    newCaptionApi.getTtsText(textId.value,ttsStatus.value).then((res) => {
           console.log('重新获取数据')
           console.log(res)
           if(res.code==200){
            editData.value = res.data
            captionTextOld.value = JSON.parse(JSON.stringify(res.data))
            ttstore.updatattsListData(res.data)
           }
        })
}
// 所有项目
const allProject=()=>{
    router.push("/index/aiApply/projectList")
}
//新项目
const newProject=()=>{
    router.push("/index/aiApply/project")
}
// 视频进度条拖拽进度
const updataNumFun=(even:number)=>{
    console.log('视频进度条拖拽进度'+even)
    console.log(totalTime.value)
    if (isMp4.value) {
        videoRef.value.pause()

    } else {
        audioRef.value.pause()

    }
    startTime.value =even * totalTime.value/100
    // 视频跳转
    if (isMp4.value) {
        // videoRef.value.pause()
        videoRef.value.currentTime =(startTime.value/1000)
    } else {
        // audioRef.value.pause()
        audioRef.value.currentTime =(startTime.value/1000)
    }
    if (playShow.value) {
        if (isMp4.value) {
            videoRef.value.play()

        } else {
            audioRef.value.play()

        }
    }
     
    console.log('startTime.value'+startTime.value)
    // cnText.value = ''
    // enText.value = ''
    editData.value.forEach((item, index) => {
        if (startTime.value >= item.beginTime && startTime.value <= item.endTime) {
            cnText.value = item.original.text
            if(item.translation!=undefined){
                enText.value = item.translation.text || ''
            }
            
            // 字幕滚动条移动
            if (clickIndex.value < 0) {
                // console.log('字幕滚动条移动'+index)
                // scrollAreaRef.value.scrollTop = (60 * (index - 3))
                scrollAreaRef.value!.setScrollTop(60 * (index - 3))
            }
            styleInde.value = (index )
        }

    })

    waveChild.value.elDrak(even, totalTime.value)
}
// 放大播放视频
const showMask=ref(false)
const toshowMask=()=>{
    console.log('放大播放视频')
    showMask.value=true
    // if(playShow.value){
    //     playPause()
    // }
   
}
// 拖拽缩放页面
const drawLine = ref()
const editMain = ref()
const editMainLeft = ref()
const editMainRight = ref()
const startX = ref(0);
const dragWidth = ref(0);
const mousedownLine = (e: any) => {
    // console.log(e)
    // console.log(e.clientX)
    e.preventDefault();
    startX.value = e.clientX
    dragWidth.value = editMainLeft.value.offsetWidth;
    console.log(dragWidth.value)
    document.addEventListener('mousemove', doDrag)
    document.documentElement.addEventListener('mouseup', stopDrag);
}
const doDrag = (event: any) => {
    const clientX = event.clientX
    const offsetX = clientX - startX.value;
    const containerWidth = editMain.value.offsetWidth;
   

    let newDragWidth = dragWidth.value + offsetX;

    // 添加最小宽度和最大宽度限制
    if (newDragWidth < 300) {
        newDragWidth = 300;
    } else if (newDragWidth > 860) {
        newDragWidth = 860;
    }

    const newListPageWidth = (newDragWidth / containerWidth) * 100;
    const newListDetailWidth = 98 - newListPageWidth;

    editMainLeft.value.style.width = newListPageWidth + '%';
    editMainLeft.value.style.flex = `0 0 ${newListPageWidth}%`;
    editMainLeft.value.style.maxWidth = newListPageWidth + '%';

    //   editMainRight.value.style.width = newListDetailWidth + '%';
    //   editMainRight.value.style.flex = `0 0 ${newListDetailWidth}%`;
    //   editMainRight.value.style.maxWidth = newListDetailWidth + '%';
}
const stopDrag = () => {
    document.removeEventListener('mousemove', doDrag)
}
// 文本放大
const textLarge=ref(false)
const textToLarge=()=>{
    console.log('文本放大')
    textLarge.value=!textLarge.value
}
// 
const showlodaing=ref(false)

return (_ctx: any,_cache: any) => {
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_color_picker = _resolveComponent("el-color-picker")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _withDirectives(_createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("img", {
            src: _imports_0,
            alt: "",
            class: "logoImg",
            onMouseover: _cache[0] || (_cache[0] = ($event: any) => (menuShow.value=true))
          }, null, 32)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createTextVNode(_toDisplayString(_unref(applicationDetail).caption.name) + " ", 1),
            _createElementVNode("span", null, _toDisplayString(_unref(applicationDetail).caption.version), 1)
          ]),
          _createVNode(selectBox, {
            ref_key: "selectRef",
            ref: selectRef,
            class: "selecTostyle",
            newShow: true,
            allShow: true,
            onChangeSelect: changeSelect
          }, null, 512),
          _cache[47] || (_cache[47] = _createElementVNode("div", { class: "topCommentLineCss" }, null, -1)),
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_el_tooltip, {
              content: "保存",
              placement: "bottom"
            }, {
              default: _withCtx(() => [
                _createElementVNode("img", {
                  src: _imports_1,
                  alt: "",
                  onClick: _withModifiers(funSave, ["stop"])
                })
              ]),
              _: 1
            }),
            (showSavePage.value)
              ? (_openBlock(), _createBlock(savePage, {
                  key: 0,
                  class: "saveStyle",
                  onCloseThis: _cache[1] || (_cache[1] = ($event: any) => (showSavePage.value=false)),
                  id: textId.value,
                  onReVersionList: getVersionList
                }, null, 8, ["id"]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_el_tooltip, {
              content: "撤销",
              placement: "bottom"
            }, {
              default: _withCtx(() => [
                _createElementVNode("img", {
                  src: _imports_2,
                  alt: "",
                  onClick: _withModifiers(revoke, ["stop"])
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_tooltip, {
              content: "恢复",
              placement: "bottom"
            }, {
              default: _withCtx(() => [
                _createElementVNode("img", {
                  src: _imports_3,
                  alt: "",
                  onClick: _withModifiers(restores, ["stop"])
                })
              ]),
              _: 1
            })
          ]),
          _cache[48] || (_cache[48] = _createElementVNode("div", { class: "topCommentLineCss" }, null, -1)),
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_el_tooltip, {
              content: "简繁转换",
              placement: "bottom"
            }, {
              default: _withCtx(() => [
                (!simplifiedShow.value)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      src: _imports_4,
                      alt: "",
                      onClick: _withModifiers(simplifiedFun, ["stop"])
                    }))
                  : _createCommentVNode("", true),
                (simplifiedShow.value)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 1,
                      src: _imports_5,
                      alt: "",
                      onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (simplifiedShow.value = false), ["stop"]))
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            (simplifiedShow.value)
              ? (_openBlock(), _createBlock(simplified, {
                  key: 0,
                  class: "simplifiedStyle",
                  onSimplifiedFun: simplifiedTo,
                  onCloseThis: closeAll,
                  onClick: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["stop"]))
                }))
              : _createCommentVNode("", true)
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_10, [
            _createVNode(_component_el_tooltip, {
              content: "AI翻译",
              placement: "bottom"
            }, {
              default: _withCtx(() => [
                _createElementVNode("img", {
                  src: _imports_6,
                  alt: "",
                  onClick: _withModifiers(translateBoxFun, ["stop"])
                })
              ]),
              _: 1
            }),
            (translateBoxShow.value)
              ? (_openBlock(), _createBlock(translate, {
                  key: 0,
                  class: "translateBox",
                  onCloseThis: closeAll,
                  languagefrom: language.value,
                  onClick: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["stop"])),
                  onRecognition: newTranslate
                }, null, 8, ["languagefrom"]))
              : _createCommentVNode("", true)
          ], 512), [
            [_vShow, !deltranslatShow.value && isMy.value]
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_11, [
            (!translatShow.value && deltranslatShow.value)
              ? (_openBlock(), _createBlock(_component_el_tooltip, {
                  key: 0,
                  content: "显示译文",
                  placement: "bottom"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("img", {
                      src: _imports_7,
                      alt: "",
                      onClick: _withModifiers(hidetranslat, ["stop"])
                    })
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (translatShow.value && deltranslatShow.value)
              ? (_openBlock(), _createBlock(_component_el_tooltip, {
                  key: 1,
                  content: "隐藏译文",
                  placement: "bottom"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("img", {
                      src: _imports_8,
                      alt: "",
                      onClick: _withModifiers(hidetranslat, ["stop"])
                    })
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ], 512), [
            [_vShow, isMy.value]
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_12, [
            _createVNode(_component_el_tooltip, {
              content: "删除译文",
              placement: "bottom"
            }, {
              default: _withCtx(() => [
                _createElementVNode("img", {
                  src: _imports_9,
                  alt: "",
                  onClick: _withModifiers(openConvert, ["stop"])
                })
              ]),
              _: 1
            })
          ], 512), [
            [_vShow, isMy.value&&deltranslatShow.value]
          ]),
          _cache[49] || (_cache[49] = _createElementVNode("div", { class: "topCommentLineCss" }, null, -1)),
          _createElementVNode("div", _hoisted_13, [
            _createVNode(_component_el_tooltip, {
              content: "检查规则",
              placement: "bottom"
            }, {
              default: _withCtx(() => [
                ( !textinspectShow.value)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      src: _imports_10,
                      alt: "",
                      onClick: _withModifiers(controlFun, ["stop"])
                    }))
                  : _createCommentVNode("", true),
                (textinspectShow.value)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 1,
                      src: _imports_11,
                      alt: "",
                      onClick: _withModifiers(controlFun, ["stop"])
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            (ruleShow.value)
              ? (_openBlock(), _createBlock(control, {
                  key: 0,
                  class: "controlStyle",
                  initRule: checkRule.value,
                  textfilterShow: textfilterShow.value,
                  textinspectShow: textinspectShow.value,
                  onChangeRule: changeRuleFun,
                  onOpenRule: openRuleFun,
                  onOpenFilterTxt: openFilterTxtFun,
                  onCloseThis: closeAll,
                  onClick: _cache[5] || (_cache[5] = _withModifiers(() => {}, ["stop"]))
                }, null, 8, ["initRule", "textfilterShow", "textinspectShow"]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createVNode(_component_el_tooltip, {
              content: "查找/替换",
              placement: "bottom"
            }, {
              default: _withCtx(() => [
                (!findReplaceShow.value)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      src: _imports_12,
                      alt: "",
                      onClick: _withModifiers(findReplaceFun, ["stop"])
                    }))
                  : _createCommentVNode("", true),
                (findReplaceShow.value)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 1,
                      src: _imports_13,
                      alt: "",
                      onClick: _cache[6] || (_cache[6] = _withModifiers(($event: any) => (findReplaceShow.value=false), ["stop"]))
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            (findReplaceShow.value)
              ? (_openBlock(), _createBlock(findReplace, {
                  key: 0,
                  list: editData.value,
                  onCloseThis: _cache[7] || (_cache[7] = ($event: any) => (findReplaceShow.value=false)),
                  deltranslatShow: deltranslatShow.value,
                  onReplaceWord: replaceWordFun,
                  onShowTxtThis: showTxtThis,
                  textId: textId.value,
                  onFilterListFun: filterListFun
                }, null, 8, ["list", "deltranslatShow", "textId"]))
              : _createCommentVNode("", true)
          ]),
          _cache[50] || (_cache[50] = _createElementVNode("div", { class: "topCommentLineCss" }, null, -1)),
          _createElementVNode("div", _hoisted_15, [
            _createVNode(_component_el_tooltip, {
              content: "上传",
              placement: "bottom"
            }, {
              default: _withCtx(() => [
                (!uploadSrtShow.value)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      src: _imports_14,
                      alt: "",
                      onClick: _withModifiers(uploadSrtFun, ["stop"])
                    }))
                  : _createCommentVNode("", true),
                (uploadSrtShow.value)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 1,
                      src: _imports_15,
                      alt: "",
                      onClick: _cache[8] || (_cache[8] = _withModifiers(($event: any) => (uploadSrtShow.value=false), ["stop"]))
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            (uploadSrtShow.value)
              ? (_openBlock(), _createBlock(uploadSrt, {
                  key: 0,
                  class: "uploadSrtStyle",
                  id: textId.value,
                  onReshowSrtText: reSrtText,
                  onCloseThis: _cache[9] || (_cache[9] = ($event: any) => (uploadSrtShow.value=false))
                }, null, 8, ["id"]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_16, [
            _createVNode(_component_el_tooltip, {
              content: "下载",
              placement: "bottom"
            }, {
              default: _withCtx(() => [
                (!exportShow.value)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      src: _imports_16,
                      alt: "",
                      onClick: _withModifiers(exportOpen, ["stop"])
                    }))
                  : _createCommentVNode("", true),
                (exportShow.value)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 1,
                      src: _imports_17,
                      alt: "",
                      onClick: _cache[10] || (_cache[10] = _withModifiers(($event: any) => (uploadSrtShow.value=false), ["stop"]))
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            (exportShow.value)
              ? (_openBlock(), _createBlock(exports, {
                  key: 0,
                  class: "exportStyle",
                  id: textId.value,
                  titleText: initTitle.value,
                  onCloseThis: _cache[11] || (_cache[11] = ($event: any) => (exportShow.value=false)),
                  onClick: _cache[12] || (_cache[12] = _withModifiers(() => {}, ["stop"]))
                }, null, 8, ["id", "titleText"]))
              : _createCommentVNode("", true)
          ]),
          _cache[51] || (_cache[51] = _createElementVNode("div", { class: "topCommentLineCss" }, null, -1)),
          (isMy.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                (!roleImgShow.value)
                  ? (_openBlock(), _createBlock(_component_el_tooltip, {
                      key: 0,
                      content: "显示角色",
                      placement: "bottom"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("img", {
                          src: _imports_18,
                          alt: "",
                          onClick: _withModifiers(roleImgFun, ["stop"])
                        })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (roleImgShow.value)
                  ? (_openBlock(), _createBlock(_component_el_tooltip, {
                      key: 1,
                      content: "隐藏角色",
                      placement: "bottom"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("img", {
                          src: _imports_19,
                          alt: "",
                          onClick: _withModifiers(roleImgFun, ["stop"])
                        })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_18, [
            (!timeBoxShow.value)
              ? (_openBlock(), _createBlock(_component_el_tooltip, {
                  key: 0,
                  content: "显示时间码",
                  placement: "bottom"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("img", {
                      src: _imports_20,
                      alt: "",
                      onClick: _withModifiers(timeBoxFun, ["stop"])
                    })
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (timeBoxShow.value)
              ? (_openBlock(), _createBlock(_component_el_tooltip, {
                  key: 1,
                  content: "隐藏时间码",
                  placement: "bottom"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("img", {
                      src: _imports_21,
                      alt: "",
                      onClick: _withModifiers(timeBoxFun, ["stop"])
                    })
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_19, [
            _createVNode(_component_el_tooltip, {
              content: "编辑记录",
              placement: "bottom"
            }, {
              default: _withCtx(() => [
                _createElementVNode("img", {
                  src: _imports_22,
                  alt: "",
                  onClick: _withModifiers(funEditAll, ["stop"])
                })
              ]),
              _: 1
            })
          ]),
          (isMy.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                _createVNode(ttsPage, {
                  onOpenttsDown: openttsDown,
                  controlTts: controlTts.value,
                  ref_key: "ttsPageRef",
                  ref: ttsPageRef
                }, null, 8, ["controlTts"])
              ]))
            : _createCommentVNode("", true),
          (isMy.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                _createVNode(_component_el_tooltip, {
                  content: "协同编辑",
                  placement: "bottom"
                }, {
                  default: _withCtx(() => [
                    (!shareBoxShow.value)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          src: _imports_23,
                          alt: "",
                          onClick: _withModifiers(shareBoxFun, ["stop"])
                        }))
                      : _createCommentVNode("", true),
                    (shareBoxShow.value)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 1,
                          src: _imports_24,
                          alt: "",
                          onClick: _cache[13] || (_cache[13] = _withModifiers(($event: any) => (shareBoxShow.value=false), ["stop"]))
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }),
                (shareBoxShow.value)
                  ? (_openBlock(), _createBlock(shareBox, {
                      key: 0,
                      class: "shareStyle",
                      roles: shareUsers.value,
                      titleText: initTitle.value,
                      id: textId.value,
                      onCloseThis: _cache[14] || (_cache[14] = ($event: any) => (shareBoxShow.value=false)),
                      onClick: _cache[15] || (_cache[15] = _withModifiers(() => {}, ["stop"]))
                    }, null, 8, ["roles", "titleText", "id"]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_22, [
            _createElementVNode("div", {
              class: "versionBox",
              onClick: _withModifiers(versionBoxFun, ["stop"])
            }, [
              _cache[46] || (_cache[46] = _createElementVNode("span", { class: "versionBoxNameLeft" }, "当前版本:", -1)),
              _createElementVNode("span", _hoisted_23, _toDisplayString(selVersionName.value), 1),
              (!versionBoxShow.value)
                ? (_openBlock(), _createBlock(_component_el_icon, { key: 0 }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(ArrowDown))
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (versionBoxShow.value)
                ? (_openBlock(), _createBlock(_component_el_icon, { key: 1 }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(ArrowUp))
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (versionBoxShow.value)
                ? (_openBlock(), _createBlock(versionList, {
                    key: 2,
                    class: "versionPopup",
                    onSelvs: versionSel,
                    onCloseThis: _cache[16] || (_cache[16] = ($event: any) => (versionBoxShow.value=false)),
                    onClick: _cache[17] || (_cache[17] = _withModifiers(() => {}, ["stop"])),
                    versionBoxData: versionS.value,
                    id: textId.value,
                    subtitle: subtitleId.value,
                    onReVersionList: getVersionList
                  }, null, 8, ["versionBoxData", "id", "subtitle"]))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_24, [
            _createVNode(_component_el_tooltip, {
              content: "退出",
              placement: "bottom"
            }, {
              default: _withCtx(() => [
                _createElementVNode("img", {
                  src: _imports_25,
                  alt: "",
                  onClick: _withModifiers(allProject, ["stop"])
                })
              ]),
              _: 1
            })
          ])
        ]),
        _createVNode(mainBox, {
          class: "topMain",
          ref_key: "mainBoxRef",
          ref: mainBoxRef,
          onCloseAll: closeAll
        }, null, 512),
        _withDirectives(_createVNode(menuPage, {
          class: "menuPageStyle",
          onClosemenu: _cache[18] || (_cache[18] = ($event: any) => (menuShow.value=false)),
          onOpenmenu: _cache[19] || (_cache[19] = ($event: any) => (menuShow.value=true)),
          nameInfo: _unref(applicationDetail).caption
        }, null, 8, ["nameInfo"]), [
          [_vShow, menuShow.value]
        ])
      ], 512), [
        [_vShow, !showMask.value]
      ]),
      _createElementVNode("div", {
        class: "captionsBtm",
        ref_key: "editMain",
        ref: editMain,
        style: _normalizeStyle(textLarge.value?{paddingBottom: '.8rem'}:{paddingBottom: '24.4rem'})
      }, [
        _withDirectives(_createElementVNode("div", {
          class: "captionsBtmLeft",
          style: _normalizeStyle(!roleImgShow.value ? leftBorder : ''),
          ref_key: "editMainLeft",
          ref: editMainLeft
        }, [
          _createElementVNode("div", {
            class: "videoBox",
            style: _normalizeStyle(roleImgShow.value ? leftBorder : '')
          }, [
            _createElementVNode("div", _hoisted_25, [
              _createElementVNode("div", _hoisted_26, _toDisplayString(initTitle.value), 1)
            ]),
            _createElementVNode("div", {
              class: "videoShow",
              onClick: _withModifiers(playPause, ["stop"])
            }, [
              (!isMp4.value)
                ? (_openBlock(), _createElementBlock("audio", {
                    key: 0,
                    src: _unref(proxy).getfileUrl+aUrl.value,
                    ref_key: "audioRef",
                    ref: audioRef,
                    onTimeupdate: updateCurrentTime
                  }, null, 40, _hoisted_27))
                : _createCommentVNode("", true),
              (isMp4.value)
                ? (_openBlock(), _createElementBlock("video", {
                    key: 1,
                    src: _unref(proxy).getfileUrl+aUrl.value,
                    ref_key: "videoRef",
                    ref: videoRef,
                    onTimeupdate: updateCurrentTime,
                    muted: ismuted.value
                  }, null, 40, _hoisted_28))
                : _createCommentVNode("", true),
              _createElementVNode("audio", {
                src: _unref(proxy).getfileUrl+ttsUrl.value,
                onLoadedmetadata: handleTimeUpdate,
                style: {"display":"hidden"},
                ref_key: "ttsVideoRef",
                ref: ttsVideoRef
              }, null, 40, _hoisted_29)
            ]),
            _withDirectives(_createElementVNode("div", {
              class: "videoText",
              style: _normalizeStyle({fontSize:textSize.value+'px'})
            }, [
              _createElementVNode("span", null, _toDisplayString(cnText.value), 1),
              _createElementVNode("span", null, _toDisplayString(enText.value), 1)
            ], 4), [
              [_vShow, textShow.value]
            ])
          ], 4),
          _createElementVNode("div", _hoisted_30, [
            (roleImgShow.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                  _createElementVNode("div", _hoisted_32, [
                    _cache[55] || (_cache[55] = _createElementVNode("div", { class: "rolesTitle" }, " 人物角色 ", -1)),
                    _createElementVNode("div", _hoisted_33, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(roleListBox.value, (item, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "roleOneBox",
                          key: index
                        }, [
                          _createElementVNode("div", {
                            class: "roleOneBoxInner",
                            onMouseover: ($event: any) => (overRole.value=index),
                            onMouseout: _cache[20] || (_cache[20] = ($event: any) => (_ctx.overIndex=-1))
                          }, [
                            _createElementVNode("div", _hoisted_35, [
                              (item.avatar == undefined||item.avatar =='')
                                ? (_openBlock(), _createElementBlock("img", {
                                    key: 0,
                                    src: _unref(headPic)
                                  }, null, 8, _hoisted_36))
                                : _createCommentVNode("", true),
                              (item.avatar != undefined&&item.avatar != '')
                                ? (_openBlock(), _createElementBlock("img", {
                                    key: 1,
                                    src: _unref(proxy).getimgUrl+item.avatar
                                  }, null, 8, _hoisted_37))
                                : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("div", _hoisted_38, _toDisplayString(item.name), 1),
                            (overRole.value==index)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                                  _createVNode(_component_el_icon, {
                                    class: "roleOneBoxImgDel",
                                    color: "rgba(255, 255, 255, .6)",
                                    onClick: _withModifiers(($event: any) => (delRole(item, index)), ["stop"])
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_unref(Close))
                                    ]),
                                    _: 2
                                  }, 1032, ["onClick"]),
                                  _createElementVNode("div", {
                                    class: "roleOneBoxImg",
                                    onClick: _withModifiers(($event: any) => (openRole(item, index)), ["stop"])
                                  }, _cache[52] || (_cache[52] = [
                                    _createElementVNode("img", {
                                      src: _imports_26,
                                      alt: ""
                                    }, null, -1)
                                  ]), 8, _hoisted_40)
                                ]))
                              : _createCommentVNode("", true)
                          ], 40, _hoisted_34),
                          (isTtsOpen.value&&item.status!=undefined&&item.status==1)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_41, _cache[53] || (_cache[53] = [
                                _createElementVNode("span", null, "幻音TTS", -1),
                                _createElementVNode("span", null, "配音生成中", -1)
                              ])))
                            : _createCommentVNode("", true)
                        ]))
                      }), 128)),
                      _createElementVNode("div", {
                        class: "roleOneBox",
                        onClick: _withModifiers(addRoleBox, ["stop"])
                      }, [
                        _createElementVNode("div", _hoisted_42, [
                          _createElementVNode("div", _hoisted_43, [
                            _createElementVNode("img", {
                              src: _unref(headPic),
                              alt: ""
                            }, null, 8, _hoisted_44)
                          ]),
                          _cache[54] || (_cache[54] = _createElementVNode("div", { class: "roleOneBoxName" }, " 新增 ", -1))
                        ])
                      ])
                    ]),
                    (roleImgShow.value && roleImgBoxShow.value)
                      ? (_openBlock(), _createBlock(roleEdit, {
                          key: 0,
                          class: "roleEditStyle",
                          onCloseThis: closeAll,
                          roleOne: roleEditOne.value,
                          onEditRoleImgfun: editRoleImg,
                          onClick: _cache[21] || (_cache[21] = _withModifiers(() => {}, ["stop"]))
                        }, null, 8, ["roleOne"]))
                      : _createCommentVNode("", true)
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ], 4), [
          [_vShow, !textLarge.value]
        ]),
        _createElementVNode("div", _hoisted_45, [
          (!textLarge.value)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "editMainDrag",
                ref_key: "drawLine",
                ref: drawLine,
                onMousedown: _cache[22] || (_cache[22] = ($event: any) => (mousedownLine($event)))
              }, _cache[56] || (_cache[56] = [
                _createElementVNode("img", {
                  src: _imports_27,
                  alt: ""
                }, null, -1)
              ]), 544))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_46, [
            _createElementVNode("div", _hoisted_47, [
              _createElementVNode("div", {
                class: "captionsTableHead",
                style: _normalizeStyle(timeBoxShow.value?{'paddingLeft':'22.2rem'}:{'paddingLeft':'13.6rem'})
              }, [
                _createElementVNode("div", {
                  class: "tableHeadLeft",
                  style: _normalizeStyle(timeBoxShow.value?{'width':'19rem'}:{'width':'12rem'})
                }, [
                  _cache[57] || (_cache[57] = _createElementVNode("div", { class: "indexNumber" }, "序号", -1)),
                  (timeBoxShow.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_48, "时间码"))
                    : _createCommentVNode("", true),
                  (roleImgShow.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_49, "头像"))
                    : _createCommentVNode("", true)
                ], 4),
                _createElementVNode("div", _hoisted_50, [
                  _createElementVNode("div", _hoisted_51, [
                    _createElementVNode("div", _hoisted_52, [
                      _cache[59] || (_cache[59] = _createTextVNode(" 字幕 ")),
                      (isMy.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
                            _cache[58] || (_cache[58] = _createElementVNode("span", null, "协作:", -1)),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(shareUsers.value, (item, index) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: index,
                                class: "shareImgList"
                              }, [
                                (item.avatar!=undefined&&item.avatar!=''&&item.share)
                                  ? (_openBlock(), _createElementBlock("img", {
                                      key: 0,
                                      src: _unref(proxy).getimgUrl+item.avatar,
                                      alt: ""
                                    }, null, 8, _hoisted_54))
                                  : _createCommentVNode("", true),
                                ((item.avatar==undefined || item.avatar=='')&&item.share)
                                  ? (_openBlock(), _createElementBlock("img", {
                                      key: 1,
                                      src: _unref(headPic),
                                      alt: ""
                                    }, null, 8, _hoisted_55))
                                  : _createCommentVNode("", true)
                              ]))
                            }), 128))
                          ]))
                        : _createCommentVNode("", true),
                      _cache[60] || (_cache[60] = _createElementVNode("span", { class: "captionsTextWordRight" }, "标记", -1))
                    ])
                  ]),
                  _cache[61] || (_cache[61] = _createElementVNode("div", { class: "captionsInfo" }, [
                    _createElementVNode("div", { class: "keyLength" }, "字符"),
                    _createElementVNode("div", { class: "timeLang" }, "时长(秒)")
                  ], -1))
                ]),
                _cache[62] || (_cache[62] = _createElementVNode("div", { class: "tableHeadRightTxt" }, [
                  _createElementVNode("span", null, "备注")
                ], -1)),
                _createElementVNode("div", _hoisted_56, [
                  (!textLarge.value)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        src: _imports_28,
                        alt: "",
                        onClick: _withModifiers(textToLarge, ["stop"])
                      }))
                    : _createCommentVNode("", true),
                  (textLarge.value)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 1,
                        src: _imports_29,
                        alt: "",
                        onClick: _withModifiers(textToLarge, ["stop"])
                      }))
                    : _createCommentVNode("", true)
                ])
              ], 4),
              _createElementVNode("div", _hoisted_57, [
                _withDirectives(_createVNode(_unref(ElScrollbar), {
                  ref_key: "scrollAreaRef",
                  ref: scrollAreaRef,
                  onHandleScroll: _cache[31] || (_cache[31] = ($event: any) => ( console.log('========')))
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(editData.value, (item, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: _normalizeClass(["captionsTableList", (isTtsHeightLight.value&&((!isTtsDubbing.value &&item.ttsAudio!=undefined&&item.ttsAudio.audioDuration>(item.endTime-item.beginTime))||(isTtsDubbing.value &&item.ttsAudio!=undefined&&item.ttsAudio.audioDuration>(item.endTime-item.beginTime))))?'captionsTableListErr':'']),
                        key: index,
                        style: _normalizeStyle(styleInde.value == (index )||overThisRow.value==index ? styleDetail : '')
                      }, [
                        _createElementVNode("div", {
                          class: "captionsTableListInner",
                          style: _normalizeStyle((timeBoxShow.value)?{'paddingLeft':'20.6rem'}:{'paddingLeft':'13.6rem'}),
                          onContextmenu: _withModifiers(($event: any) => (preventDefault($event, item, index)), ["prevent"]),
                          onMouseover: ($event: any) => (overThisRow.value=index),
                          onMouseout: _cache[30] || (_cache[30] = ($event: any) => (focusColor.value?'':overThisRow.value=-1))
                        }, [
                          _createElementVNode("div", {
                            class: "tableListLeft",
                            style: _normalizeStyle(timeBoxShow.value?{'width':'19rem'}:{'width':'12rem'})
                          }, [
                            (isTtsOpen.value&&item.ttsAudio!=undefined&&item.ttsAudio.status==100)
                              ? (_openBlock(), _createBlock(ttsMultiple, {
                                  key: 0,
                                  class: "styleMultiple",
                                  multiple: item.ttsAudio.speed,
                                  onClick: _withModifiers(($event: any) => {closeAll();ttsMultipleIndex.value=index;}, ["stop"]),
                                  onUpdateMultiple: updateMultiple,
                                  onOff: ttsMultipleIndex.value==index
                                }, null, 8, ["multiple", "onClick", "onOff"]))
                              : _createCommentVNode("", true),
                            (isTtsOpen.value&&item.ttsAudio!=undefined&&item.ttsAudio.status==-1)
                              ? (_openBlock(), _createElementBlock("div", {
                                  key: 1,
                                  class: "ttsError",
                                  onClick: _withModifiers(($event: any) => (reTtsDubbing(item)), ["stop"])
                                }, [
                                  _cache[63] || (_cache[63] = _createElementVNode("span", null, "生成失败", -1)),
                                  _createVNode(_component_el_icon, { style: {"margin-left":"0.2rem","margin-top":"0.1rem"} }, {
                                    default: _withCtx(() => [
                                      _createVNode(_unref(Refresh))
                                    ]),
                                    _: 1
                                  })
                                ], 8, _hoisted_59))
                              : _createCommentVNode("", true),
                            _createElementVNode("div", {
                              class: "indexNumber",
                              onClick: _withModifiers(($event: any) => (rePlatText(item, index )), ["stop"]),
                              onMouseover: ($event: any) => (overThisRow.value=index)
                            }, [
                              (overThisRow.value!=index)
                                ? (_openBlock(), _createElementBlock("span", {
                                    key: 0,
                                    onMouseover: ($event: any) => (overThisRow.value=index)
                                  }, _toDisplayString(index + 1), 41, _hoisted_61))
                                : _createCommentVNode("", true),
                              (!item.isPlay&&overThisRow.value==index)
                                ? (_openBlock(), _createElementBlock("img", {
                                    key: 1,
                                    src: _imports_30,
                                    alt: "",
                                    onMouseover: ($event: any) => (overThisRow.value=index)
                                  }, null, 40, _hoisted_62))
                                : _createCommentVNode("", true),
                              (item.isPlay&&overThisRow.value==index)
                                ? (_openBlock(), _createElementBlock("img", _hoisted_63))
                                : _createCommentVNode("", true)
                            ], 40, _hoisted_60),
                            (timeBoxShow.value)
                              ? (_openBlock(), _createElementBlock("div", {
                                  key: 2,
                                  class: "timeNumber",
                                  onClick: _withModifiers(($event: any) => (rePlatText(item, index )), ["stop"])
                                }, [
                                  _createElementVNode("div", _hoisted_65, _toDisplayString(_unref(timeInfo)(item.beginTime)), 1),
                                  _createElementVNode("div", _hoisted_66, _toDisplayString(_unref(timeInfo)(item.endTime)), 1)
                                ], 8, _hoisted_64))
                              : _createCommentVNode("", true),
                            (roleImgShow.value)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_67, [
                                  (item.role != undefined&&item.role != '')
                                    ? (_openBlock(), _createElementBlock("div", {
                                        key: 0,
                                        class: "imgBox",
                                        onClick: _withModifiers(($event: any) => (showImgList(index)), ["stop"])
                                      }, [
                                        (roleListBox.value.filter(it => it.id == item.role)[0].avatar != undefined && roleListBox.value.filter(it => it.id == item.role)[0].avatar != '')
                                          ? (_openBlock(), _createElementBlock("img", {
                                              key: 0,
                                              src: _unref(proxy).getimgUrl+roleListBox.value.filter(it => it.id == item.role)[0].avatar,
                                              alt: ""
                                            }, null, 8, _hoisted_69))
                                          : _createCommentVNode("", true),
                                        (item.role == undefined || roleListBox.value.filter(it => it.id == item.role)[0].avatar == undefined || roleListBox.value.filter(it => it.id == item.role)[0].avatar == '')
                                          ? (_openBlock(), _createElementBlock("img", {
                                              key: 1,
                                              src: _unref(headPic),
                                              alt: ""
                                            }, null, 8, _hoisted_70))
                                          : _createCommentVNode("", true),
                                        _createElementVNode("span", null, _toDisplayString(roleListBox.value.filter(it => it.id == item.role)[0].name), 1)
                                      ], 8, _hoisted_68))
                                    : _createCommentVNode("", true),
                                  (item.role == undefined||item.role == '')
                                    ? (_openBlock(), _createElementBlock("div", {
                                        key: 1,
                                        class: "imgBoxNo",
                                        onClick: _withModifiers(($event: any) => (showImgList(index)), ["stop"])
                                      }, null, 8, _hoisted_71))
                                    : _createCommentVNode("", true),
                                  (showImgListIndex.value == index)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_72, [
                                        _createElementVNode("div", _hoisted_73, [
                                          _cache[64] || (_cache[64] = _createElementVNode("span", null, "更改头像", -1)),
                                          _createVNode(_component_el_icon, {
                                            class: "closeBtn",
                                            onClick: _withModifiers(closeroleImgList, ["stop"])
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_unref(Close))
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _createElementVNode("div", _hoisted_74, [
                                          _createVNode(_unref(ElScrollbar), null, {
                                            default: _withCtx(() => [
                                              _createElementVNode("div", _hoisted_75, [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(roleListBox.value, (it, indexIt) => {
                                                  return (_openBlock(), _createElementBlock("div", {
                                                    class: "roleImgOne",
                                                    onClick: _withModifiers(($event: any) => (selectOne(item, index, it.id)), ["stop"]),
                                                    key: indexIt
                                                  }, [
                                                    (it.avatar == undefined||it.avatar == '')
                                                      ? (_openBlock(), _createElementBlock("img", {
                                                          key: 0,
                                                          src: _unref(headPic),
                                                          alt: ""
                                                        }, null, 8, _hoisted_77))
                                                      : _createCommentVNode("", true),
                                                    (it.avatar != undefined&&it.avatar != '')
                                                      ? (_openBlock(), _createElementBlock("img", {
                                                          key: 1,
                                                          src: _unref(proxy).getimgUrl + it.avatar,
                                                          alt: ""
                                                        }, null, 8, _hoisted_78))
                                                      : _createCommentVNode("", true),
                                                    _createElementVNode("span", null, _toDisplayString(it.name), 1)
                                                  ], 8, _hoisted_76))
                                                }), 128))
                                              ])
                                            ]),
                                            _: 2
                                          }, 1024)
                                        ])
                                      ]))
                                    : _createCommentVNode("", true)
                                ]))
                              : _createCommentVNode("", true)
                          ], 4),
                          _createElementVNode("div", _hoisted_79, [
                            _createElementVNode("div", _hoisted_80, [
                              _createElementVNode("div", _hoisted_81, [
                                (editTextIndex.value != index || editTextIndexType.value != 'cn' || editTextIndexType.value == '')
                                  ? (_openBlock(), _createElementBlock("div", {
                                      key: 0,
                                      class: "textBox",
                                      onClick: _withModifiers(($event: any) => (editText(index, 'cn', item)), ["stop"]),
                                      style: _normalizeStyle(item.original.textColor != undefined ? { color: item.original.textColor } : { color: '' })
                                    }, _toDisplayString(item.original.text), 13, _hoisted_82))
                                  : _createCommentVNode("", true),
                                (editTextIndex.value == index && editTextIndexType.value == 'cn')
                                  ? _withDirectives((_openBlock(), _createElementBlock("input", {
                                      key: 1,
                                      "onUpdate:modelValue": ($event: any) => ((item.original.text) = $event),
                                      onInput: ($event: any) => (updataText('cn', index, item.original.text)),
                                      onBlur: originalEdit,
                                      autofocus: "",
                                      onClick: _cache[23] || (_cache[23] = _withModifiers(() => {}, ["stop"])),
                                      onKeydown: [
                                        _withKeys(($event: any) => (handleEnter($event,item.original.text,index,item)), ["enter"]),
                                        _withKeys(($event: any) => (handleDelete($event,item.original.text,index,item)), ["delete"])
                                      ]
                                    }, null, 40, _hoisted_83)), [
                                      [_vModelText, item.original.text]
                                    ])
                                  : _createCommentVNode("", true),
                                _withDirectives(_createElementVNode("div", _hoisted_84, [
                                  (item.original.textColor!=undefined)
                                    ? (_openBlock(), _createBlock(_component_el_color_picker, {
                                        key: 0,
                                        modelValue: item.original.textColor  ,
                                        "onUpdate:modelValue": ($event: any) => ((item.original.textColor  ) = $event),
                                        size: "small",
                                        predefine: predefineColors,
                                        onFocus: ($event: any) => (focusColorfun(index, 'cnColor', item)),
                                        onChange: ($event: any) => (changeColor(index, 'cn', $event, item))
                                      }, null, 8, ["modelValue", "onUpdate:modelValue", "onFocus", "onChange"]))
                                    : _createCommentVNode("", true),
                                  (item.original.textColor==undefined)
                                    ? (_openBlock(), _createBlock(_component_el_color_picker, {
                                        key: 1,
                                        modelValue: initColor,
                                        "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((initColor) = $event)),
                                        size: "small",
                                        predefine: predefineColors,
                                        onFocus: ($event: any) => (focusColorfun(index, 'cnColor', item)),
                                        onChange: ($event: any) => (changeColor(index, 'cn', $event, item))
                                      }, null, 8, ["onFocus", "onChange"]))
                                    : _createCommentVNode("", true)
                                ], 512), [
                                  [_vShow, overThisRow.value==index]
                                ])
                              ]),
                              (translatShow.value && deltranslatShow.value)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_85, [
                                    (editTextIndex.value != index || editTextIndexType.value != 'en' || editTextIndexType.value == '')
                                      ? (_openBlock(), _createElementBlock("div", {
                                          key: 0,
                                          class: "textBox",
                                          onClick: _withModifiers(($event: any) => (editText(index, 'en', item)), ["stop"]),
                                          style: _normalizeStyle((item.translation!=undefined && item.translation.textColor != undefined) ? { color: item.translation.textColor } : { color: '' })
                                        }, _toDisplayString(item.translation.text), 13, _hoisted_86))
                                      : _createCommentVNode("", true),
                                    (editTextIndex.value == index && editTextIndexType.value == 'en')
                                      ? _withDirectives((_openBlock(), _createElementBlock("input", {
                                          key: 1,
                                          "onUpdate:modelValue": ($event: any) => ((item.translation.text) = $event),
                                          onInput: ($event: any) => (updataText('en', index, item.translation.text)),
                                          onBlur: translationEdit,
                                          autofocus: "",
                                          onClick: _cache[25] || (_cache[25] = _withModifiers(() => {}, ["stop"]))
                                        }, null, 40, _hoisted_87)), [
                                          [_vModelText, item.translation.text]
                                        ])
                                      : _createCommentVNode("", true),
                                    _withDirectives(_createElementVNode("div", _hoisted_88, [
                                      ((item.translation!=undefined && item.translation.textColor != undefined))
                                        ? (_openBlock(), _createBlock(_component_el_color_picker, {
                                            key: 0,
                                            modelValue: item.translation.textColor ,
                                            "onUpdate:modelValue": ($event: any) => ((item.translation.textColor ) = $event),
                                            predefine: predefineColors,
                                            size: "small",
                                            onFocus: ($event: any) => (focusColorfun(index, 'enColor', item)),
                                            onChange: ($event: any) => (changeColor(index, 'en', $event, item))
                                          }, null, 8, ["modelValue", "onUpdate:modelValue", "onFocus", "onChange"]))
                                        : _createCommentVNode("", true),
                                      ((item.translation!=undefined && item.translation.textColor != undefined))
                                        ? (_openBlock(), _createBlock(_component_el_color_picker, {
                                            key: 1,
                                            modelValue: initColor,
                                            "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((initColor) = $event)),
                                            size: "small",
                                            predefine: predefineColors,
                                            onFocus: ($event: any) => (focusColorfun(index, 'enColor', item)),
                                            onChange: ($event: any) => (changeColor(index, 'en', $event, item))
                                          }, null, 8, ["onFocus", "onChange"]))
                                        : _createCommentVNode("", true)
                                    ], 512), [
                                      [_vShow, overThisRow.value==index]
                                    ])
                                  ]))
                                : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("div", _hoisted_89, [
                              _createElementVNode("div", _hoisted_90, [
                                _createElementVNode("div", {
                                  style: _normalizeStyle((textinspectShow.value && ((item.original.text.length) > checkRule.value.originalMaximumWordCount)) ? styleinspectRule : '')
                                }, _toDisplayString(item.original.text.length), 5),
                                (translatShow.value && item.translation!=undefined &&item.translation.text!=undefined)
                                  ? (_openBlock(), _createElementBlock("div", {
                                      key: 0,
                                      style: _normalizeStyle((textinspectShow.value && ((item.translation.text.length) > checkRule.value.translationOriginalMaximumWordCount)) ? styleinspectRule : '')
                                    }, _toDisplayString(item.translation.text.length), 5))
                                  : _createCommentVNode("", true)
                              ]),
                              _createElementVNode("div", {
                                class: "timeLang",
                                style: _normalizeStyle((textinspectShow.value && ((((item.endTime - item.beginTime) / 1000)) > checkRule.value.maximumDuration || (((item.endTime - item.beginTime) / 1000)) < checkRule.value.minimumDuration)) ? styleinspectRule : '')
                              }, _toDisplayString(((item.endTime - item.beginTime) / 1000).toFixed(2)) + " 秒 ", 5),
                              _createElementVNode("div", _hoisted_91, [
                                _withDirectives(_createElementVNode("div", _hoisted_92, [
                                  _createElementVNode("img", {
                                    src: _imports_32,
                                    alt: "",
                                    onClick: _withModifiers(($event: any) => (showMessage(index, 'cn', item)), ["stop"])
                                  }, null, 8, _hoisted_93),
                                  (item.original.comments!=undefined&& item.original.comments.length>0)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_94, _toDisplayString(item.original.comments.length), 1))
                                    : _createCommentVNode("", true)
                                ], 512), [
                                  [_vShow, overThisRow.value==index || (item.original.comments!=undefined && item.original.comments.length>0) ]
                                ]),
                                _withDirectives(_createElementVNode("div", _hoisted_95, [
                                  (translatShow.value)
                                    ? (_openBlock(), _createElementBlock("img", {
                                        key: 0,
                                        src: _imports_32,
                                        alt: "",
                                        onClick: _withModifiers(($event: any) => (showMessage(index, 'en', item)), ["stop"])
                                      }, null, 8, _hoisted_96))
                                    : _createCommentVNode("", true),
                                  (item.translation!=undefined &&  item.translation.comments!=undefined&& item.translation.comments.length>0)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_97, _toDisplayString(item.translation.comments.length), 1))
                                    : _createCommentVNode("", true)
                                ], 512), [
                                  [_vShow, (translatShow.value && (overThisRow.value==index||(item.translation!=undefined && item.translation.comments!=undefined&& item.translation.comments.length>0)))]
                                ]),
                                (showMessageIndex.value == index)
                                  ? (_openBlock(), _createElementBlock("div", {
                                      key: 0,
                                      class: "textMessagePage",
                                      onClick: _cache[29] || (_cache[29] = _withModifiers(() => {}, ["stop"]))
                                    }, [
                                      _createElementVNode("div", _hoisted_98, [
                                        (mainImg.value.avatar!=undefined && mainImg.value.avatar!='')
                                          ? (_openBlock(), _createElementBlock("img", {
                                              key: 0,
                                              src: _unref(proxy).getimgUrl+ mainImg.value.avatar,
                                              alt: ""
                                            }, null, 8, _hoisted_99))
                                          : _createCommentVNode("", true),
                                        (mainImg.value.avatar==undefined && mainImg.value.avatar=='')
                                          ? (_openBlock(), _createElementBlock("img", {
                                              key: 1,
                                              src: _unref(headPic),
                                              alt: ""
                                            }, null, 8, _hoisted_100))
                                          : _createCommentVNode("", true),
                                        _withDirectives(_createElementVNode("textarea", {
                                          name: "",
                                          id: "",
                                          cols: "30",
                                          rows: "10",
                                          "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((contentSend).value = $event))
                                        }, null, 512), [
                                          [_vModelText, contentSend.value]
                                        ]),
                                        _createVNode(_component_el_button, {
                                          size: "small",
                                          type: "primary",
                                          onClick: _withModifiers(($event: any) => (sendMsg(item.id, index, 'addOriginalComment')), ["stop"]),
                                          style: {"margin-top":"2rem"}
                                        }, {
                                          default: _withCtx(() => _cache[65] || (_cache[65] = [
                                            _createTextVNode("发送")
                                          ])),
                                          _: 2
                                        }, 1032, ["onClick"]),
                                        _createVNode(_component_el_icon, {
                                          class: "closeBtn",
                                          onClick: _cache[28] || (_cache[28] = _withModifiers(($event: any) => (showMessageIndex.value =-1), ["stop"]))
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_unref(Close))
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      (comments.value.length > 0)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_101, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(comments.value, (it, its) => {
                                              return (_openBlock(), _createElementBlock("div", {
                                                key: its,
                                                class: "pageSendBoxOne"
                                              }, [
                                                _createElementVNode("div", _hoisted_102, [
                                                  _createElementVNode("div", _hoisted_103, [
                                                    (shareUsers.value.filter(itt => itt.userId == it.userId)[0].avatar!='')
                                                      ? (_openBlock(), _createElementBlock("img", {
                                                          key: 0,
                                                          src: _unref(proxy).getimgUrl+ shareUsers.value.filter(itt => itt.userId == it.userId)[0].avatar,
                                                          alt: ""
                                                        }, null, 8, _hoisted_104))
                                                      : _createCommentVNode("", true),
                                                    (shareUsers.value.filter(itt => itt.userId == it.userId)[0].avatar=='')
                                                      ? (_openBlock(), _createElementBlock("img", {
                                                          key: 1,
                                                          src: _unref(headPic),
                                                          alt: ""
                                                        }, null, 8, _hoisted_105))
                                                      : _createCommentVNode("", true),
                                                    _createElementVNode("span", null, _toDisplayString(shareUsers.value.filter(itt => itt.userId == it.userId)[0].nickname), 1)
                                                  ]),
                                                  _createElementVNode("span", null, _toDisplayString(_unref(timedata)(it.createTime*1)), 1)
                                                ]),
                                                _createElementVNode("div", _hoisted_106, [
                                                  _createTextVNode(_toDisplayString(it.content) + " ", 1),
                                                  _createVNode(_component_el_icon, {
                                                    class: "pageSenDdel",
                                                    onClick: _withModifiers(($event: any) => (delMsg(item.id, index,it.id)), ["stop"])
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_unref(Delete))
                                                    ]),
                                                    _: 2
                                                  }, 1032, ["onClick"])
                                                ])
                                              ]))
                                            }), 128))
                                          ]))
                                        : _createCommentVNode("", true)
                                    ]))
                                  : _createCommentVNode("", true)
                              ])
                            ])
                          ])
                        ], 44, _hoisted_58),
                        (item.ttsAudio!=undefined&&item.ttsAudio.status!=100&&item.ttsAudio.status>0&&isTtsOpen.value)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_107, " 幻音TTS 配音生成中... "))
                          : _createCommentVNode("", true)
                      ], 6))
                    }), 128))
                  ]),
                  _: 1
                }, 512), [
                  [_vShow, !findReplaceShow.value&&!textfilterShow.value]
                ]),
                _withDirectives(_createVNode(_unref(ElScrollbar), {
                  ref_key: "scrollPlaceRef",
                  ref: scrollPlaceRef
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filterList.value, (item, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "captionsTableList",
                        key: index,
                        style: _normalizeStyle(replaceIndex.value == index ? styleDetail : '')
                      }, [
                        _createElementVNode("div", {
                          class: "captionsTableListInner",
                          style: _normalizeStyle((timeBoxShow.value)?{'paddingLeft':'20.6rem'}:{'paddingLeft':'13.6rem'}),
                          onContextmenu: _withModifiers(($event: any) => (preventDefault($event, item, index)), ["prevent"])
                        }, [
                          _createElementVNode("div", {
                            class: "tableListLeft",
                            style: _normalizeStyle(timeBoxShow.value?{'width':'19rem'}:{'width':'12rem'})
                          }, [
                            _createElementVNode("div", {
                              class: "indexNumber",
                              onClick: _withModifiers(($event: any) => (rePlatText(item, index )), ["stop"])
                            }, _toDisplayString(index + 1), 9, _hoisted_109),
                            (timeBoxShow.value)
                              ? (_openBlock(), _createElementBlock("div", {
                                  key: 0,
                                  class: "timeNumber",
                                  onClick: _withModifiers(($event: any) => (rePlatText(item, index )), ["stop"])
                                }, [
                                  _createElementVNode("div", _hoisted_111, _toDisplayString(_unref(timeInfo)(item.beginTime)), 1),
                                  _createElementVNode("div", _hoisted_112, _toDisplayString(_unref(timeInfo)(item.endTime)), 1)
                                ], 8, _hoisted_110))
                              : _createCommentVNode("", true),
                            (roleImgShow.value)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_113, [
                                  (item.role != undefined&&item.role != '')
                                    ? (_openBlock(), _createElementBlock("div", {
                                        key: 0,
                                        class: "imgBox",
                                        onClick: _withModifiers(($event: any) => (showImgList(index)), ["stop"])
                                      }, [
                                        (roleListBox.value.filter(it => it.id == item.role)[0].avatar != undefined)
                                          ? (_openBlock(), _createElementBlock("img", {
                                              key: 0,
                                              src: _unref(proxy).getimgUrl+roleListBox.value.filter(it => it.id == item.role)[0].avatar,
                                              alt: ""
                                            }, null, 8, _hoisted_115))
                                          : _createCommentVNode("", true),
                                        (item.role == undefined || roleListBox.value.filter(it => it.id == item.role)[0].avatar == undefined)
                                          ? (_openBlock(), _createElementBlock("img", {
                                              key: 1,
                                              src: _unref(headPic),
                                              alt: ""
                                            }, null, 8, _hoisted_116))
                                          : _createCommentVNode("", true),
                                        _createElementVNode("span", null, _toDisplayString(roleListBox.value.filter(it => it.id == item.role)[0].name), 1)
                                      ], 8, _hoisted_114))
                                    : _createCommentVNode("", true),
                                  (item.role == undefined || item.role == '')
                                    ? (_openBlock(), _createElementBlock("div", {
                                        key: 1,
                                        class: "imgBox",
                                        onClick: _withModifiers(($event: any) => (showImgList(index)), ["stop"])
                                      }, [
                                        _createElementVNode("img", {
                                          src: _unref(headPic),
                                          alt: ""
                                        }, null, 8, _hoisted_118)
                                      ], 8, _hoisted_117))
                                    : _createCommentVNode("", true)
                                ]))
                              : _createCommentVNode("", true)
                          ], 4),
                          _createElementVNode("div", _hoisted_119, [
                            _createElementVNode("div", _hoisted_120, [
                              _createElementVNode("div", _hoisted_121, [
                                _createElementVNode("div", {
                                  class: "textBox",
                                  style: _normalizeStyle(item.original.textColor != undefined ? { color: item.original.textColor } : { color: '' })
                                }, _toDisplayString(item.original.text), 5)
                              ]),
                              (translatShow.value && deltranslatShow.value)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_122, [
                                    _createElementVNode("div", {
                                      class: "textBox",
                                      style: _normalizeStyle((item.translation!=undefined && item.translation.textColor != undefined) ? { color: item.translation.textColor } : { color: '' })
                                    }, _toDisplayString(item.translation.text), 5)
                                  ]))
                                : _createCommentVNode("", true)
                            ])
                          ])
                        ], 44, _hoisted_108)
                      ], 4))
                    }), 128))
                  ]),
                  _: 1
                }, 512), [
                  [_vShow, findReplaceShow.value&&!textfilterShow.value]
                ]),
                _withDirectives(_createVNode(_unref(ElScrollbar), {
                  ref_key: "scrollPlaceRef",
                  ref: scrollPlaceRef
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filterRuleList.value, (item, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: _normalizeClass(["captionsTableList", (isTtsHeightLight.value&&((!isTtsDubbing.value &&item.ttsAudio!=undefined&&item.ttsAudio.audioDuration>(item.endTime-item.beginTime))||(isTtsDubbing.value &&item.ttsAudio!=undefined&&item.ttsAudio.audioDuration>(item.endTime-item.beginTime))))?'captionsTableListErr':'']),
                        key: index,
                        style: _normalizeStyle(styleInde.value == (index )||overThisRow.value==index ? styleDetail : '')
                      }, [
                        _createElementVNode("div", {
                          class: "captionsTableListInner",
                          style: _normalizeStyle((timeBoxShow.value)?{'paddingLeft':'20.6rem'}:{'paddingLeft':'13.6rem'}),
                          onContextmenu: _withModifiers(($event: any) => (preventDefault($event, item, index)), ["prevent"]),
                          onMouseover: ($event: any) => (overThisRow.value=index),
                          onMouseout: _cache[39] || (_cache[39] = ($event: any) => (focusColor.value?'':overThisRow.value=-1))
                        }, [
                          _createElementVNode("div", {
                            class: "tableListLeft",
                            style: _normalizeStyle(timeBoxShow.value?{'width':'19rem'}:{'width':'12rem'})
                          }, [
                            (isTtsOpen.value&&item.ttsAudio!=undefined&&item.ttsAudio.status==100)
                              ? (_openBlock(), _createBlock(ttsMultiple, {
                                  key: 0,
                                  class: "styleMultiple",
                                  multiple: item.ttsAudio.speed,
                                  onClick: _withModifiers(($event: any) => {closeAll();ttsMultipleIndex.value=index;}, ["stop"]),
                                  onUpdateMultiple: updateMultiple,
                                  onOff: ttsMultipleIndex.value==index
                                }, null, 8, ["multiple", "onClick", "onOff"]))
                              : _createCommentVNode("", true),
                            (isTtsOpen.value&&item.ttsAudio!=undefined&&item.ttsAudio.status==-1)
                              ? (_openBlock(), _createElementBlock("div", {
                                  key: 1,
                                  class: "ttsError",
                                  onClick: _withModifiers(($event: any) => (reTtsDubbing(item)), ["stop"])
                                }, [
                                  _cache[66] || (_cache[66] = _createElementVNode("span", null, "生成失败", -1)),
                                  _createVNode(_component_el_icon, { style: {"margin-left":"0.2rem","margin-top":"0.1rem"} }, {
                                    default: _withCtx(() => [
                                      _createVNode(_unref(Refresh))
                                    ]),
                                    _: 1
                                  })
                                ], 8, _hoisted_124))
                              : _createCommentVNode("", true),
                            _createElementVNode("div", {
                              class: "indexNumber",
                              onClick: _withModifiers(($event: any) => (rePlatText(item, index )), ["stop"]),
                              onMouseover: ($event: any) => (overThisRow.value=index)
                            }, [
                              (overThisRow.value!=index)
                                ? (_openBlock(), _createElementBlock("span", {
                                    key: 0,
                                    onMouseover: ($event: any) => (overThisRow.value=index)
                                  }, _toDisplayString(index + 1), 41, _hoisted_126))
                                : _createCommentVNode("", true),
                              (!item.isPlay&&overThisRow.value==index)
                                ? (_openBlock(), _createElementBlock("img", {
                                    key: 1,
                                    src: _imports_30,
                                    alt: "",
                                    onMouseover: ($event: any) => (overThisRow.value=index)
                                  }, null, 40, _hoisted_127))
                                : _createCommentVNode("", true),
                              (item.isPlay&&overThisRow.value==index)
                                ? (_openBlock(), _createElementBlock("img", _hoisted_128))
                                : _createCommentVNode("", true)
                            ], 40, _hoisted_125),
                            (timeBoxShow.value)
                              ? (_openBlock(), _createElementBlock("div", {
                                  key: 2,
                                  class: "timeNumber",
                                  onClick: _withModifiers(($event: any) => (rePlatText(item, index )), ["stop"])
                                }, [
                                  _createElementVNode("div", _hoisted_130, _toDisplayString(_unref(timeInfo)(item.beginTime)), 1),
                                  _createElementVNode("div", _hoisted_131, _toDisplayString(_unref(timeInfo)(item.endTime)), 1)
                                ], 8, _hoisted_129))
                              : _createCommentVNode("", true),
                            (roleImgShow.value)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_132, [
                                  (item.role != undefined&&item.role != '')
                                    ? (_openBlock(), _createElementBlock("div", {
                                        key: 0,
                                        class: "imgBox",
                                        onClick: _withModifiers(($event: any) => (showImgList(index)), ["stop"])
                                      }, [
                                        (roleListBox.value.filter(it => it.id == item.role)[0].avatar != undefined && roleListBox.value.filter(it => it.id == item.role)[0].avatar != '')
                                          ? (_openBlock(), _createElementBlock("img", {
                                              key: 0,
                                              src: _unref(proxy).getimgUrl+roleListBox.value.filter(it => it.id == item.role)[0].avatar,
                                              alt: ""
                                            }, null, 8, _hoisted_134))
                                          : _createCommentVNode("", true),
                                        (item.role == undefined || roleListBox.value.filter(it => it.id == item.role)[0].avatar == undefined || roleListBox.value.filter(it => it.id == item.role)[0].avatar == '')
                                          ? (_openBlock(), _createElementBlock("img", {
                                              key: 1,
                                              src: _unref(headPic),
                                              alt: ""
                                            }, null, 8, _hoisted_135))
                                          : _createCommentVNode("", true),
                                        _createElementVNode("span", null, _toDisplayString(roleListBox.value.filter(it => it.id == item.role)[0].name), 1)
                                      ], 8, _hoisted_133))
                                    : _createCommentVNode("", true),
                                  (item.role == undefined||item.role == '')
                                    ? (_openBlock(), _createElementBlock("div", {
                                        key: 1,
                                        class: "imgBox",
                                        onClick: _withModifiers(($event: any) => (showImgList(index)), ["stop"])
                                      }, [
                                        _createElementVNode("img", {
                                          src: _unref(headPic),
                                          alt: ""
                                        }, null, 8, _hoisted_137)
                                      ], 8, _hoisted_136))
                                    : _createCommentVNode("", true),
                                  (showImgListIndex.value == index)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_138, [
                                        _createElementVNode("div", _hoisted_139, [
                                          _cache[67] || (_cache[67] = _createElementVNode("span", null, "更改头像", -1)),
                                          _createVNode(_component_el_icon, {
                                            class: "closeBtn",
                                            onClick: _withModifiers(closeroleImgList, ["stop"])
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_unref(Close))
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _createElementVNode("div", _hoisted_140, [
                                          _createVNode(_unref(ElScrollbar), null, {
                                            default: _withCtx(() => [
                                              _createElementVNode("div", _hoisted_141, [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(roleListBox.value, (it, indexIt) => {
                                                  return (_openBlock(), _createElementBlock("div", {
                                                    class: "roleImgOne",
                                                    onClick: _withModifiers(($event: any) => (selectOne(item, index, it.id)), ["stop"]),
                                                    key: indexIt
                                                  }, [
                                                    (it.avatar == undefined||it.avatar == '')
                                                      ? (_openBlock(), _createElementBlock("img", {
                                                          key: 0,
                                                          src: _unref(headPic),
                                                          alt: ""
                                                        }, null, 8, _hoisted_143))
                                                      : _createCommentVNode("", true),
                                                    (it.avatar != undefined&&it.avatar != '')
                                                      ? (_openBlock(), _createElementBlock("img", {
                                                          key: 1,
                                                          src: _unref(proxy).getimgUrl + it.avatar,
                                                          alt: ""
                                                        }, null, 8, _hoisted_144))
                                                      : _createCommentVNode("", true),
                                                    _createElementVNode("span", null, _toDisplayString(it.name), 1)
                                                  ], 8, _hoisted_142))
                                                }), 128))
                                              ])
                                            ]),
                                            _: 2
                                          }, 1024)
                                        ])
                                      ]))
                                    : _createCommentVNode("", true)
                                ]))
                              : _createCommentVNode("", true)
                          ], 4),
                          _createElementVNode("div", _hoisted_145, [
                            _createElementVNode("div", _hoisted_146, [
                              _createElementVNode("div", _hoisted_147, [
                                (editTextIndex.value != index || editTextIndexType.value != 'cn' || editTextIndexType.value == '')
                                  ? (_openBlock(), _createElementBlock("div", {
                                      key: 0,
                                      class: "textBox",
                                      onClick: _withModifiers(($event: any) => (editText(index, 'cn', item)), ["stop"]),
                                      style: _normalizeStyle(item.original.textColor != undefined ? { color: item.original.textColor } : { color: '' })
                                    }, _toDisplayString(item.original.text), 13, _hoisted_148))
                                  : _createCommentVNode("", true),
                                (editTextIndex.value == index && editTextIndexType.value == 'cn')
                                  ? _withDirectives((_openBlock(), _createElementBlock("input", {
                                      key: 1,
                                      "onUpdate:modelValue": ($event: any) => ((item.original.text) = $event),
                                      onInput: ($event: any) => (updataText('cn', index, item.original.text)),
                                      onBlur: originalEdit,
                                      autofocus: "",
                                      onClick: _cache[32] || (_cache[32] = _withModifiers(() => {}, ["stop"]))
                                    }, null, 40, _hoisted_149)), [
                                      [_vModelText, item.original.text]
                                    ])
                                  : _createCommentVNode("", true),
                                _withDirectives(_createElementVNode("div", _hoisted_150, [
                                  (item.original.textColor!=undefined)
                                    ? (_openBlock(), _createBlock(_component_el_color_picker, {
                                        key: 0,
                                        modelValue: item.original.textColor  ,
                                        "onUpdate:modelValue": ($event: any) => ((item.original.textColor  ) = $event),
                                        size: "small",
                                        predefine: predefineColors,
                                        onFocus: ($event: any) => (focusColorfun(index, 'cnColor', item)),
                                        onChange: ($event: any) => (changeColor(index, 'cn', $event, item))
                                      }, null, 8, ["modelValue", "onUpdate:modelValue", "onFocus", "onChange"]))
                                    : _createCommentVNode("", true),
                                  (item.original.textColor==undefined)
                                    ? (_openBlock(), _createBlock(_component_el_color_picker, {
                                        key: 1,
                                        modelValue: initColor,
                                        "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((initColor) = $event)),
                                        size: "small",
                                        predefine: predefineColors,
                                        onFocus: ($event: any) => (focusColorfun(index, 'cnColor', item)),
                                        onChange: ($event: any) => (changeColor(index, 'cn', $event, item))
                                      }, null, 8, ["onFocus", "onChange"]))
                                    : _createCommentVNode("", true)
                                ], 512), [
                                  [_vShow, overThisRow.value==index]
                                ])
                              ]),
                              (translatShow.value && deltranslatShow.value)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_151, [
                                    (editTextIndex.value != index || editTextIndexType.value != 'en' || editTextIndexType.value == '')
                                      ? (_openBlock(), _createElementBlock("div", {
                                          key: 0,
                                          class: "textBox",
                                          onClick: _withModifiers(($event: any) => (editText(index, 'en', item)), ["stop"]),
                                          style: _normalizeStyle((item.translation!=undefined && item.translation.textColor != undefined) ? { color: item.translation.textColor } : { color: '' })
                                        }, _toDisplayString(item.translation.text), 13, _hoisted_152))
                                      : _createCommentVNode("", true),
                                    (editTextIndex.value == index && editTextIndexType.value == 'en')
                                      ? _withDirectives((_openBlock(), _createElementBlock("input", {
                                          key: 1,
                                          "onUpdate:modelValue": ($event: any) => ((item.translation.text) = $event),
                                          onInput: ($event: any) => (updataText('en', index, item.translation.text)),
                                          onBlur: translationEdit,
                                          autofocus: "",
                                          onClick: _cache[34] || (_cache[34] = _withModifiers(() => {}, ["stop"]))
                                        }, null, 40, _hoisted_153)), [
                                          [_vModelText, item.translation.text]
                                        ])
                                      : _createCommentVNode("", true),
                                    _withDirectives(_createElementVNode("div", _hoisted_154, [
                                      ((item.translation!=undefined && item.translation.textColor != undefined))
                                        ? (_openBlock(), _createBlock(_component_el_color_picker, {
                                            key: 0,
                                            modelValue: item.translation.textColor ,
                                            "onUpdate:modelValue": ($event: any) => ((item.translation.textColor ) = $event),
                                            predefine: predefineColors,
                                            size: "small",
                                            onFocus: ($event: any) => (focusColorfun(index, 'enColor', item)),
                                            onChange: ($event: any) => (changeColor(index, 'en', $event, item))
                                          }, null, 8, ["modelValue", "onUpdate:modelValue", "onFocus", "onChange"]))
                                        : _createCommentVNode("", true),
                                      ((item.translation!=undefined && item.translation.textColor == undefined))
                                        ? (_openBlock(), _createBlock(_component_el_color_picker, {
                                            key: 1,
                                            modelValue: initColor,
                                            "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => ((initColor) = $event)),
                                            size: "small",
                                            predefine: predefineColors,
                                            onFocus: ($event: any) => (focusColorfun(index, 'enColor', item)),
                                            onChange: ($event: any) => (changeColor(index, 'en', $event, item))
                                          }, null, 8, ["onFocus", "onChange"]))
                                        : _createCommentVNode("", true)
                                    ], 512), [
                                      [_vShow, overThisRow.value==index]
                                    ])
                                  ]))
                                : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("div", _hoisted_155, [
                              _createElementVNode("div", _hoisted_156, [
                                _createElementVNode("div", {
                                  style: _normalizeStyle((textinspectShow.value && ((item.original.text.length) > checkRule.value.originalMaximumWordCount)) ? styleinspectRule : '')
                                }, _toDisplayString(item.original.text.length), 5),
                                (translatShow.value && item.translation!=undefined &&item.translation.text!=undefined)
                                  ? (_openBlock(), _createElementBlock("div", {
                                      key: 0,
                                      style: _normalizeStyle((textinspectShow.value && ((item.translation.text.length) > checkRule.value.translationOriginalMaximumWordCount)) ? styleinspectRule : '')
                                    }, _toDisplayString(item.translation.text.length), 5))
                                  : _createCommentVNode("", true)
                              ]),
                              _createElementVNode("div", {
                                class: "timeLang",
                                style: _normalizeStyle((textinspectShow.value && ((((item.endTime - item.beginTime) / 1000)) > checkRule.value.maximumDuration || (((item.endTime - item.beginTime) / 1000)) < checkRule.value.minimumDuration)) ? styleinspectRule : '')
                              }, _toDisplayString(((item.endTime - item.beginTime) / 1000).toFixed(2)) + " 秒 ", 5),
                              _createElementVNode("div", _hoisted_157, [
                                _withDirectives(_createElementVNode("div", _hoisted_158, [
                                  _createElementVNode("img", {
                                    src: _imports_32,
                                    alt: "",
                                    onClick: _withModifiers(($event: any) => (showMessage(index, 'cn', item)), ["stop"])
                                  }, null, 8, _hoisted_159),
                                  (item.original.comments!=undefined&& item.original.comments.length>0)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_160, _toDisplayString(item.original.comments.length), 1))
                                    : _createCommentVNode("", true)
                                ], 512), [
                                  [_vShow, overThisRow.value==index || (item.original.comments!=undefined && item.original.comments.length>0) ]
                                ]),
                                _withDirectives(_createElementVNode("div", _hoisted_161, [
                                  (translatShow.value)
                                    ? (_openBlock(), _createElementBlock("img", {
                                        key: 0,
                                        src: _imports_32,
                                        alt: "",
                                        onClick: _withModifiers(($event: any) => (showMessage(index, 'en', item)), ["stop"])
                                      }, null, 8, _hoisted_162))
                                    : _createCommentVNode("", true),
                                  (item.translation!=undefined &&  item.translation.comments!=undefined&& item.translation.comments.length>0)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_163, _toDisplayString(item.translation.comments.length), 1))
                                    : _createCommentVNode("", true)
                                ], 512), [
                                  [_vShow, (translatShow.value && (overThisRow.value==index||(item.translation!=undefined && item.translation.comments!=undefined&& item.translation.comments.length>0)))]
                                ]),
                                (showMessageIndex.value == index)
                                  ? (_openBlock(), _createElementBlock("div", {
                                      key: 0,
                                      class: "textMessagePage",
                                      onClick: _cache[38] || (_cache[38] = _withModifiers(() => {}, ["stop"]))
                                    }, [
                                      _createElementVNode("div", _hoisted_164, [
                                        (mainImg.value.avatar!=undefined && mainImg.value.avatar!='')
                                          ? (_openBlock(), _createElementBlock("img", {
                                              key: 0,
                                              src: _unref(proxy).getimgUrl+ mainImg.value.avatar,
                                              alt: ""
                                            }, null, 8, _hoisted_165))
                                          : _createCommentVNode("", true),
                                        (mainImg.value.avatar==undefined && mainImg.value.avatar=='')
                                          ? (_openBlock(), _createElementBlock("img", {
                                              key: 1,
                                              src: _unref(headPic),
                                              alt: ""
                                            }, null, 8, _hoisted_166))
                                          : _createCommentVNode("", true),
                                        _withDirectives(_createElementVNode("textarea", {
                                          name: "",
                                          id: "",
                                          cols: "30",
                                          rows: "10",
                                          "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => ((contentSend).value = $event))
                                        }, null, 512), [
                                          [_vModelText, contentSend.value]
                                        ]),
                                        _createVNode(_component_el_button, {
                                          size: "small",
                                          type: "primary",
                                          onClick: _withModifiers(($event: any) => (sendMsg(item.id, index, 'addOriginalComment')), ["stop"]),
                                          style: {"margin-top":"2rem"}
                                        }, {
                                          default: _withCtx(() => _cache[68] || (_cache[68] = [
                                            _createTextVNode("发送")
                                          ])),
                                          _: 2
                                        }, 1032, ["onClick"]),
                                        _createVNode(_component_el_icon, {
                                          class: "closeBtn",
                                          onClick: _cache[37] || (_cache[37] = _withModifiers(($event: any) => (showMessageIndex.value =-1), ["stop"]))
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_unref(Close))
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      (comments.value.length > 0)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_167, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(comments.value, (it, its) => {
                                              return (_openBlock(), _createElementBlock("div", {
                                                key: its,
                                                class: "pageSendBoxOne"
                                              }, [
                                                _createElementVNode("div", _hoisted_168, [
                                                  _createElementVNode("div", _hoisted_169, [
                                                    (shareUsers.value.filter(itt => itt.userId == it.userId)[0].avatar!='')
                                                      ? (_openBlock(), _createElementBlock("img", {
                                                          key: 0,
                                                          src: _unref(proxy).getimgUrl+ shareUsers.value.filter(itt => itt.userId == it.userId)[0].avatar,
                                                          alt: ""
                                                        }, null, 8, _hoisted_170))
                                                      : _createCommentVNode("", true),
                                                    (shareUsers.value.filter(itt => itt.userId == it.userId)[0].avatar=='')
                                                      ? (_openBlock(), _createElementBlock("img", {
                                                          key: 1,
                                                          src: _unref(headPic),
                                                          alt: ""
                                                        }, null, 8, _hoisted_171))
                                                      : _createCommentVNode("", true),
                                                    _createElementVNode("span", null, _toDisplayString(shareUsers.value.filter(itt => itt.userId == it.userId)[0].nickname), 1)
                                                  ]),
                                                  _createElementVNode("span", null, _toDisplayString(_unref(timedata)(it.createTime*1)), 1)
                                                ]),
                                                _createElementVNode("div", _hoisted_172, [
                                                  _createTextVNode(_toDisplayString(it.content) + " ", 1),
                                                  _createVNode(_component_el_icon, {
                                                    class: "pageSenDdel",
                                                    onClick: _withModifiers(($event: any) => (delMsg(item.id, index,it.id)), ["stop"])
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_unref(Delete))
                                                    ]),
                                                    _: 2
                                                  }, 1032, ["onClick"])
                                                ])
                                              ]))
                                            }), 128))
                                          ]))
                                        : _createCommentVNode("", true)
                                    ]))
                                  : _createCommentVNode("", true)
                              ])
                            ])
                          ])
                        ], 44, _hoisted_123),
                        (item.ttsAudio!=undefined&&item.ttsAudio.status!=100&&item.ttsAudio.status>0&&isTtsOpen.value)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_173, " 幻音TTS 配音生成中... "))
                          : _createCommentVNode("", true)
                      ], 6))
                    }), 128))
                  ]),
                  _: 1
                }, 512), [
                  [_vShow, textfilterShow.value]
                ]),
                (busyRefShow.value)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      ref_key: "busyRef",
                      ref: busyRef,
                      class: "busyStyle"
                    }, [
                      _createElementVNode("div", {
                        onClick: _withModifiers(mergeText, ["stop"])
                      }, "向下合并"),
                      _createElementVNode("div", {
                        onClick: _withModifiers(busyAdd, ["stop"])
                      }, "拆分"),
                      _createElementVNode("div", {
                        onClick: _withModifiers(busyHistory, ["stop"])
                      }, "历史编辑"),
                      _createElementVNode("div", {
                        class: "busyDel",
                        onClick: _withModifiers(busyDelFun, ["stop"])
                      }, "删除")
                    ], 512))
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_174, [
          _createElementVNode("div", _hoisted_175, [
            _createElementVNode("div", _hoisted_176, [
              _createElementVNode("div", _hoisted_177, [
                _createVNode(_unref(sliderPoint), {
                  class: "videoRateLine",
                  num: startTime.value*1,
                  max: totalTime.value,
                  onUpdataNum: updataNumFun
                }, null, 8, ["num", "max"])
              ]),
              _createElementVNode("div", _hoisted_178, [
                _createElementVNode("span", null, _toDisplayString(_unref(timeInfominute)(startTime.value)), 1),
                _createElementVNode("span", null, _toDisplayString(_unref(timeInfominute)((totalTime.value - startTime.value))), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_179, [
              _createElementVNode("div", _hoisted_180, [
                _createElementVNode("img", {
                  src: _imports_33,
                  alt: "",
                  class: "imgStyle",
                  onClick: _withModifiers(afterPlay, ["stop"])
                }),
                (!playShow.value)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      src: _imports_30,
                      alt: "",
                      class: "imgStyle",
                      onClick: _withModifiers(playPause, ["stop"])
                    }))
                  : _createCommentVNode("", true),
                (playShow.value)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 1,
                      src: _imports_31,
                      alt: "",
                      class: "imgStyle",
                      onClick: _withModifiers(playPause, ["stop"])
                    }))
                  : _createCommentVNode("", true),
                _createElementVNode("img", {
                  src: _imports_34,
                  alt: "",
                  class: "imgStylerun imgStyle",
                  onClick: _withModifiers(nextPlay, ["stop"])
                })
              ]),
              _createElementVNode("div", _hoisted_181, [
                _createElementVNode("img", {
                  src: _imports_35,
                  alt: "",
                  onClick: _withModifiers(textEnlarge, ["stop"])
                }),
                _createElementVNode("img", {
                  src: _imports_36,
                  alt: "",
                  onClick: _withModifiers(textShrink, ["stop"])
                }),
                _withDirectives(_createElementVNode("img", {
                  src: _imports_37,
                  alt: "",
                  onClick: _withModifiers(textToshow, ["stop"])
                }, null, 512), [
                  [_vShow, !textShow.value]
                ]),
                _withDirectives(_createElementVNode("img", {
                  src: _imports_38,
                  alt: "",
                  onClick: _withModifiers(textTohide, ["stop"])
                }, null, 512), [
                  [_vShow, textShow.value]
                ]),
                _createElementVNode("img", {
                  src: _imports_28,
                  alt: "",
                  onClick: _withModifiers(toshowMask, ["stop"])
                })
              ])
            ])
          ])
        ], 512), [
          [_vShow, !textLarge.value]
        ]),
        _withDirectives(_createElementVNode("div", {
          class: "trackBod",
          onClick: _withModifiers(closeAll, ["stop"])
        }, [
          _createElementVNode("div", {
            ref_key: "waveWidthRef",
            ref: waveWidthRef,
            class: "trackBodInner"
          }, [
            (waveCanvasShow.value)
              ? (_openBlock(), _createBlock(waveCanvas, {
                  key: 0,
                  creatData: demoData,
                  runTime: startTime.value*1,
                  onOffplay: playShow.value,
                  times: updateTimeShow.value,
                  onDragtextTime: textUpdateTime,
                  onTextBoxMove: updateTimeBoxMove,
                  onWaveOldDataText: waveOldData,
                  onLnineToTime: lnineToTimeUp,
                  onFinishPlay: finishPlayTime,
                  ref_key: "waveChild",
                  ref: waveChild
                }, null, 8, ["creatData", "runTime", "onOffplay", "times"]))
              : _createCommentVNode("", true)
          ], 512)
        ], 512), [
          [_vShow, !textLarge.value]
        ]),
        (historyEditShow.value)
          ? (_openBlock(), _createBlock(historyEdit, {
              key: 0,
              class: "historyBox",
              logs: subtitleLogsOne.value,
              onCloseThis: closeAll,
              initdata: initLog.value,
              imgs: shareUsers.value,
              roles: roleListBox.value,
              onClick: _cache[40] || (_cache[40] = _withModifiers(() => {}, ["stop"]))
            }, null, 8, ["logs", "initdata", "imgs", "roles"]))
          : _createCommentVNode("", true),
        (allHistoryShow.value)
          ? (_openBlock(), _createBlock(allHistory, {
              key: 1,
              class: "historyBox",
              onCloseThis: _cache[41] || (_cache[41] = ($event: any) => (allHistoryShow.value=false)),
              imgs: shareUsers.value,
              allLog: subtitleLogsAll.value,
              roles: roleListBox.value
            }, null, 8, ["imgs", "allLog", "roles"]))
          : _createCommentVNode("", true)
      ], 4)
    ]),
    (showMask.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_182, [
          _createVNode(videoAmplify, {
            aUrl: aUrl.value,
            isMp4: isMp4.value,
            startTime: startTime.value,
            totalTime: totalTime.value,
            playShow: playShow.value,
            cnText: cnText.value,
            enText: enText.value,
            onClick: _cache[42] || (_cache[42] = _withModifiers(() => {}, ["stop"])),
            onCloseAmplify: _cache[43] || (_cache[43] = ($event: any) => (showMask.value=false)),
            onAmplifyDrag: updataNumFun,
            onOnOffPlay: playPause
          }, null, 8, ["aUrl", "isMp4", "startTime", "totalTime", "playShow", "cnText", "enText"])
        ]))
      : _createCommentVNode("", true),
    _withDirectives(_createElementVNode("div", _hoisted_183, _cache[69] || (_cache[69] = [
      _createElementVNode("div", { class: "maskBox" }, [
        _createElementVNode("img", {
          src: _imports_39,
          style: {"width":"90px","height":"90px"}
        }),
        _createElementVNode("span", null, "正在加载资源中，请稍候...")
      ], -1)
    ]), 512), [
      [_vShow, showlodaing.value]
    ]),
    (opendelShow.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_184, [
          _createElementVNode("div", _hoisted_185, [
            _createVNode(delbox, {
              text: delText.value,
              onCloseThis: _cache[44] || (_cache[44] = ($event: any) => (opendelShow.value = false)),
              onRecognition: recognition
            }, null, 8, ["text"])
          ])
        ]))
      : _createCommentVNode("", true),
    (openDeltranslatShow.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_186, [
          _createElementVNode("div", _hoisted_187, [
            _createVNode(delbox, {
              text: deltranslatText.value,
              onCloseThis: _cache[45] || (_cache[45] = ($event: any) => (openDeltranslatShow.value = false)),
              onRecognition: confirmDelConvert
            }, null, 8, ["text"])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})